// Desteklenen diller
export const LANGUAGES = {
  tr: { name: 'Türkçe',   nativeName: 'Türkçe',   flag: '🇹🇷', countryCode: 'tr', dir: 'ltr' },
  en: { name: 'English',  nativeName: 'English',   flag: '🇬🇧', countryCode: 'gb', dir: 'ltr' },
  ar: { name: 'Arabic',   nativeName: 'العربية',   flag: '🇸🇦', countryCode: 'sa', dir: 'rtl' },
  ru: { name: 'Russian',  nativeName: 'Русский',   flag: '🇷🇺', countryCode: 'ru', dir: 'ltr' },
  de: { name: 'German',   nativeName: 'Deutsch',   flag: '🇩🇪', countryCode: 'de', dir: 'ltr' },
  fa: { name: 'Persian',  nativeName: 'فارسی',     flag: '🇮🇷', countryCode: 'ir', dir: 'rtl' },
};

// Bayrak görseli URL'si (flagcdn.com)
export const flagUrl = (countryCode, size = '20x15') =>
  `https://flagcdn.com/${size}/${countryCode}.png`;

const t = {
  // ══════════════════════════════════════════════════════
  // TÜRKÇE
  // ══════════════════════════════════════════════════════
  tr: {
    nav: {
      home: 'Anasayfa', whatWeDo: 'Neler Yapar', about: 'Hakkımızda',
      blog: 'Blog', contact: 'İletişim', login: 'Giriş Yap',
      register: 'Ücretsiz Kayıt Ol', registerShort: 'Kayıt Ol',
    },
    auth: {
      tabLogin: 'Giriş Yap', tabRegister: 'Bireysel Kayıt', tabStore: 'Mağaza Başvurusu',
      email: 'Email', password: 'Şifre', fullName: 'Ad Soyad', phone: 'Telefon',
      phoneOptional: 'Telefon (opsiyonel)', passwordConfirm: 'Şifre Tekrar',
      forgotPassword: 'Şifremi unuttum', forgotPasswordTitle: 'Şifremi Unuttum',
      forgotPasswordDesc: 'Kayıtlı e-posta adresinizi girin. Şifre sıfırlama linki göndereceğiz.',
      emailAddress: 'E-posta Adresi', sendResetLink: 'Sıfırlama Linki Gönder',
      sending: 'Gönderiliyor...', emailSent: 'E-posta Gönderildi!',
      emailSentDesc: 'kayıtlıysa sıfırlama linki gönderildi. Spam klasörünüzü de kontrol etmeyi unutmayın.',
      backToLogin: '← Giriş ekranına dön',
      loginBtn: 'Giriş Yap', loggingIn: 'Giriş yapılıyor...',
      registerBtn: 'Kayıt Ol', registering: 'Kaydediliyor...',
      storeApply: 'Başvuruyu Gönder', storeApplying: 'Gönderiliyor...',
      googleLogin: 'Google ile Giriş Yap', googleRegister: 'Google ile Kayıt Ol',
      orWith: 'veya', orWithEmail: 'veya e-posta ile',
      storeName: 'Mağaza Adı', contactPerson: 'İletişim Kişisi', address: 'Adres',
      termsConsent: 'Kullanım Koşullarını okudum ve kabul ediyorum',
      kvkkConsent: "KVKK Aydınlatma Metni'ni okudum ve kabul ediyorum",
      storeNote: 'Başvurunuz yönetici tarafından incelenecek ve onaylandığında bildirim alacaksınız.',
      sideHome: 'Ana Sayfa', sideAbout: 'Hakkımızda', sideContact: 'İletişim',
    },
    landing: {
      aiBadge: 'Yapay Zeka Destekli Emlak Raporlama',
      watchDemo: 'Demo İzle',
      statReports: 'Rapor Oluşturuldu',
      statConsultants: 'Aktif Danışman',
      statOffices: 'Gayrimenkul Ofisi',
      featuresBadge: 'Özellikler',
      featuresTitle: 'Tek Platformda Her Şey',
      featuresSubtitle: 'İş süreçlerinizi hızlandıran araçlar, profesyonel görünüm',
      aiTitle: 'Yapay Zeka ile',
      aiTitleGrad: 'Saniyeler İçinde',
      aiTitleEnd: 'Profesyonel Analiz',
      aiSubtitle: 'Saatler süren piyasa araştırmasını ve rapor yazımını yapay zekaya bırakın. Siz sadece müşterinize odaklanın.',
      aiGeminiBadge: 'Google Gemini AI Teknolojisi',
      aiStep: 'ADIM',
      aiStep1Title: 'Veri Girişi',
      aiStep1Desc: 'İlan bilgileri, konum ve fiyat aralığını sisteme girin',
      aiStep1Items: ['Adres & Konum', 'Metrekare & Oda', 'Fiyat Aralığı'],
      aiStep2Title: 'AI Analiz',
      aiStep2Desc: 'Gemini AI binlerce emsal ilanı analiz eder ve piyasayı değerlendirir',
      aiStep2Items: ['Emsal Karşılaştırma', 'Piyasa Analizi', 'Fiyat Tahmini'],
      aiStep3Title: 'Profesyonel Rapor',
      aiStep3Desc: 'Markalı, PDF destekli, paylaşıma hazır rapor oluşturulur',
      aiStep3Items: ['PDF İndir', 'Link ile Paylaş', 'Marka Kimliği'],
      aiFeatures: [
        { title: 'Otomatik Piyasa Analizi', desc: 'Bölgedeki satış trendleri, fiyat hareketleri ve piyasa dinamikleri otomatik analiz edilir.' },
        { title: 'Emsal İlan Karşılaştırması', desc: 'Benzer özellikteki ilanlar bulunur, detaylı karşılaştırma tablosu oluşturulur.' },
        { title: 'Akıllı Fiyat Tahmini', desc: 'Konum, metrekare ve özelliklere göre gerçekçi fiyat aralığı hesaplanır.' },
        { title: 'Otomatik Rapor Yazımı', desc: 'Tüm analizler profesyonel bir dille raporlanır, elle yazmaya gerek kalmaz.' },
        { title: 'Saniyeler İçinde Hazır', desc: 'Saatler süren analizler yapay zeka sayesinde dakikalar içinde tamamlanır.' },
        { title: 'Güvenli ve Özel', desc: 'Tüm verileriniz şifreli olarak saklanır, müşteri gizliliği tam olarak korunur.' },
      ],
      howBadge: 'Nasıl Çalışır?', howTitle: '3 Adımda Başlayın',
      howSubtitle: 'Kurulum gerektirmiyor, dakikalar içinde hazır',
      pricingBadge: 'Fiyatlandırma', pricingTitle: 'Basit ve Şeffaf',
      pricingSubtitle: 'Sürpriz yok, gizli ücret yok',
      pricingMonthly: '/aylık', pricingNoCard: 'Kredi kartı gerekmez',
      pricingFreeAfter: 'Onay sonrası tamamen ücretsiz',
      pricingIndividual: 'Bireysel Danışman',
      pricingOffice: 'Gayrimenkul Ofisi',
      pricingIndividualFeatures: [
        'Sınırsız rapor oluşturma', 'Yüksek kaliteli PDF indirme', 'Güvenli link ile paylaşım',
        'Yapay zeka emsal analizi', 'Kendi markası ile raporlar', 'Mobil uyumlu panel', 'Teknik destek',
      ],
      pricingOfficeFeatures: [
        'Bireysel plandaki tüm özellikler', 'Ofis yönetici paneli', 'Sınırsız danışman hesabı',
        'Danışman performans takibi', 'Tüm ofis raporlarına erişim', 'Ofis markası ile raporlar',
        'Özelleştirilmiş logo & renk', 'Öncelikli teknik destek',
      ],
      pricingStartFree: 'Hemen Başla — Ücretsiz',
      pricingApplyOffice: 'Ofis Başvurusu Yap',
      testimonialsBadge: 'Kullanıcı Yorumları',
      testimonialsTitle: 'Danışmanlar Ne Diyor?',
      testimonialsSubtitle: 'Binlerce profesyonelin güvendiği platform',
      faqBadge: 'SSS', faqTitle: 'Sık Sorulan\nSorular',
      faqSubtitle: 'Platformumuz hakkında merak ettiğiniz her şeyin yanıtı burada.',
      faqNotFound: 'Yanıt bulamadınız mı?', faqSupport: 'Destek ekibimiz 7/24 hazır.',
      faqContactUs: 'Bize Ulaşın', faqResponseTime: 'Ortalama yanıt süresi: 2 saat',
      ctaTitle: 'Hemen Başlamaya Hazır mısınız?',
      ctaSubtitle: 'Ücretsiz hesabınızı oluşturun, dakikalar içinde ilk raporunuzu hazırlayın.',
      ctaBtn: 'Ücretsiz Başla',
      footerQuickAccess: 'Hızlı Erişim', footerContact: 'İletişim',
      footerLinks: [['Anasayfa', '/'], ['Hakkımızda', '/hakkimizda'], ['İletişim', '/iletisim'], ['Giriş Yap', '/login']],
    },
    dashboard: {
      dashboard: 'Dashboard', reports: 'Raporlar', myReports: 'Raporlarım',
      listings: 'İlanlar', myListings: 'İlanlarım', newReport: 'Yeni Rapor',
      users: 'Kullanıcılar', stores: 'Mağazalar', apiKeys: 'API Anahtarları',
      stats: 'İstatistikler', siteContent: 'Site İçeriği', siteSettings: 'Site Ayarları',
      packages: 'Paketler', contactMessages: 'İletişim Mesajları',
      support: 'Destek', supportTickets: 'Destek Talepleri',
      consultants: 'Danışmanlar', myApiKey: 'API Anahtarım', myStats: 'İstatistiklerim',
      notifications: 'Bildirimler', profile: 'Profil', settings: 'Ayarlar', logout: 'Çıkış Yap',
    },
    common: {
      save: 'Kaydet', cancel: 'İptal', delete: 'Sil', edit: 'Düzenle', add: 'Ekle',
      search: 'Ara', loading: 'Yükleniyor...', saving: 'Kaydediliyor...', confirm: 'Onayla',
      close: 'Kapat', yes: 'Evet', no: 'Hayır', actions: 'İşlemler', status: 'Durum',
      date: 'Tarih', name: 'Ad', email: 'E-posta', phone: 'Telefon', back: 'Geri',
      next: 'İleri', submit: 'Gönder', upload: 'Yükle', download: 'İndir', print: 'Yazdır',
      preview: 'Önizle', share: 'Paylaş', copy: 'Kopyala', reset: 'Sıfırla', refresh: 'Yenile',
      total: 'Toplam', active: 'Aktif', passive: 'Pasif', approved: 'Onaylı',
      pending: 'Bekliyor', rejected: 'Reddedildi',
    },
    siteSettings: {
      languageTitle: 'Dil Ayarları',
      languageDesc: 'Sitenin varsayılan dilini seçin. Ziyaretçiler istedikleri zaman dili değiştirebilir.',
      defaultLanguage: 'Varsayılan Site Dili',
    },
    reports: {
      title: 'Raporlar', subtitle: 'Tüm raporlarınızı görüntüleyin ve yönetin',
      newReport: 'Yeni Rapor', createNew: 'Yeni Rapor Oluştur',
      searchPlaceholder: 'Rapor adı, danışman, müşteri ara...',
      selectMode: 'Seç', deselectAll: 'Seçimi Kaldır', selectAll: 'Tümünü Seç',
      untitled: 'Başlıksız Rapor', archivedBadge: 'Arşivlenmiş',
      preparing: 'Hazırlanıyor', pendingApproval: 'Onay Bekliyor',
      readyForPresentation: 'Sunuma Hazır', completed: 'Tamamlandı',
      consultant: 'Danışman', customer: 'Müşteri',
      restore: 'Geri Yükle', archiveTab: 'Arşiv',
      noReports: 'Henüz rapor yok', noArchived: 'Arşivde rapor yok',
      archivedDesc: 'Arşivlenen raporlar burada görünür.', noResults: 'Sonuç bulunamadı',
      loadError: 'Raporlar yüklenemedi', deleted: 'Rapor silindi', deleteError: 'Rapor silinemedi',
      archived: 'Rapor arşivlendi', archiveError: 'Arşivleme başarısız',
      restored: 'Rapor geri yüklendi', restoreError: 'Geri yükleme başarısız',
      pdfError: 'PDF oluşturulamadı', linkCopied: 'Paylaşım linki kopyalandı!',
      linkError: 'Link oluşturulamadı', statusUpdated: 'Durum güncellendi',
      statusError: 'Durum güncellenemedi', bulkDeleted: 'rapor silindi',
      bulkDeleteError: 'Bazı raporlar silinemedi',
      deleteConfirmTitle: 'Raporu silmek istediğinizden emin misiniz?',
      deleteConfirmDesc: 'Bu işlem geri alınamaz. Rapor kalıcı olarak silinecektir.',
      bulkDeleteConfirmDesc: 'Bu işlem geri alınamaz. Seçili raporlar kalıcı olarak silinecektir.',
    },
    listings: {
      title: 'İlanlar', subtitle: 'Aylık raporlama yapılacak ilanları yönetin',
      newListing: 'Yeni İlan', searchPlaceholder: 'İlan ara...',
      activeListings: 'Aktif İlanlar', archive: 'Arşiv',
      noListings: 'Henüz ilan eklenmemiş', noSearchResults: 'Arama kriterlerinize uygun ilan bulunamadı.',
      noArchived: 'Arşivde ilan yok', archivedListingsDesc: 'Silinen ilanlar burada görünecektir.',
      addFirstListing: 'İlk ilanı eklemek için "Yeni İlan" butonuna tıklayın.',
      noAssigned: 'Size atanmış ilan bulunmuyor.',
      editListing: 'İlanı Düzenle', addListing: 'Yeni İlan Ekle',
      titleLabel: 'İlan Başlığı', priceLabel: 'Fiyat', currencyLabel: 'Para Birimi',
      platforms: 'Platform İlan Numaraları', addPlatform: '+ Platform Ekle',
      platformName: 'Platform adı (ör: Sahibinden)', listingNo: 'İlan No',
      assignConsultant: 'Danışman Ata', unassigned: 'Atanmamış',
      noConsultants: 'Sistemde kayıtlı danışman bulunmuyor',
      customerInfo: 'Müşteri Bilgileri (Opsiyonel)',
      customerName: 'Müşteri Adı', customerPhone: 'Telefon', customerEmail: 'Email',
      reportDate: 'Raporlama Tarihi', reportDateNote: 'Bu tarihten 7 gün önce danışmana hatırlatma gönderilecektir.',
      notes: 'Notlar', notesPlaceholder: 'Ek notlar...',
      dialogDesc: 'İlan bilgilerini girin. Danışman atandığında bildirim gönderilecektir.',
      archivedBadge: 'Arşivlenmiş', archiveDate: 'Arşivlenme',
      notDetermined: 'Belirlenmedi', lastReport: 'Son Rapor',
      daysLeft: 'gün kaldı', overdue: 'Gecikmiş', passive: 'Pasif',
      totalListings: 'Toplam İlan', activeCount: 'Aktif',
      upcomingReports: '7 Gün İçinde Raporlanacak', delayedReports: 'Gecikmiş',
      markedReported: 'Raporlandı', restore: 'Geri Yükle', permanentDelete: 'Kalıcı Sil',
      sessionExpired: 'Oturum süresi dolmuş. Lütfen tekrar giriş yapın.',
      loadError: 'İlanlar yüklenemedi. Lütfen sayfayı yenileyin.',
      titlePriceRequired: 'İlan başlığı ve fiyat zorunludur',
      updated: 'İlan güncellendi', created: 'İlan oluşturuldu', saveError: 'İlan kaydedilemedi',
      archived: 'İlan arşive taşındı', archiveError: 'İlan arşivlenemedi',
      restored: 'İlan geri yüklendi', restoreError: 'İlan geri yüklenemedi',
      permanentlyDeleted: 'İlan kalıcı olarak silindi', deleteError: 'İlan silinemedi',
      markedReportedToast: 'Raporlandı olarak işaretlendi. Bir sonraki tarih: +30 gün',
      undoReportedToast: 'Raporlandı durumu geri alındı',
      noConsultantAssigned: 'Bu ilana danışman atanmamış',
      notifyError: 'Bildirim gönderilemedi', operationFailed: 'İşlem başarısız',
      archiveConfirmTitle: 'İlanı Arşivle',
      archiveConfirmDesc: 'ilanını arşive taşımak istediğinizden emin misiniz? Arşivlenen ilanları daha sonra geri yükleyebilirsiniz.',
      permanentDeleteConfirmTitle: 'Kalıcı Olarak Sil',
      permanentDeleteConfirmDesc: 'ilanını kalıcı olarak silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
      noResults: 'Sonuç bulunamadı', consultantsLoading: 'Yükleniyor...',
    },
    users: {
      title: 'Kullanıcı Yönetimi', searchPlaceholder: 'İsim veya e-posta ile ara...',
      total: 'Toplam', addedByAdmin: 'Admin Ekledi',
      newUser: 'Yeni Kullanıcı', fullName: 'Ad Soyad', emailLabel: 'E-Posta',
      passwordLabel: 'Şifre', roleLabel: 'Rol',
      usersTitle: 'Kullanıcılar',
      colUser: 'Kullanıcı', colRole: 'Rol', colStatus: 'Durum', colDuration: 'Süre', colActions: 'İşlem',
      roleAll: 'Tümü', roleSuperAdmin: 'Süper Admin', roleStoreAdmin: 'Mağaza Admini',
      roleConsultant: 'Danışman', roleIndividual: 'Bireysel Kullanıcı',
      roleSuperAdminLabel: 'Süper Admin', roleStoreManagerLabel: 'Mağaza Yöneticisi',
      roleConsultantLabel: 'Danışman', roleIndividualLabel: 'Bireysel',
      storeUser: 'Mağaza Kullanıcısı', individualUser: 'Bireysel Kullanıcı',
      editTitle: 'Kullanıcıyı Düzenle',
      newPassword: 'Yeni Şifre (boş bırakırsanız değişmez)',
      newPasswordPlaceholder: 'Yeni şifre girin...',
      roleChangeNote: 'Rol değişikliği kullanıcı sonraki girişte aktif olur.',
      addDuration: 'Süre Ekle', durationTitle: 'Süre Ekle',
      durationSelect: 'Süre Seçin', currentExpiry: 'Mevcut bitiş tarihi',
      durationNote: '* Mevcut bitiş tarihine eklenir. Tarih geçmişse bugünden başlar.',
      manualDays: 'Manuel Gün Sayısı', manualDaysPlaceholder: 'Örn: 45',
      durationBtn: 'Süre Ekle',
      active: 'Aktif', suspended: 'Durduruldu',
      deactivateTitle: 'Durdur', activateTitle: 'Aktifleştir',
      expired: 'Süresi Doldu', daysLeft: 'g kaldı',
      loadError: 'Liste yüklenemedi', added: 'Kullanıcı eklendi', error: 'Hata oluştu',
      deactivated: 'Hesap durduruldu', activated: 'Hesap aktifleştirildi',
      operationFailed: 'İşlem başarısız', deleted: 'Kullanıcı silindi', deleteError: 'Silme başarısız',
      updated: 'Kullanıcı güncellendi', updateFailed: 'Güncelleme başarısız',
      invalidDuration: 'Geçerli bir süre girin', durationError: 'Süre eklenemedi',
      durationAdded: 'gün eklendi. Bitiş',
      deleteConfirm: 'kullanıcısını silmek istiyor musunuz?',
      googleRegistered: 'Google ile kayıt', adminAdded: 'Admin tarafından eklendi', emailRegistered: 'E-posta ile kayıt',
    },
    support: {
      title: 'Destek Merkezi', subtitle: 'Sorunlarınızı bildirin, ekibimiz yardımcı olsun',
      newRequest: 'Yeni Talep', newTicketTitle: 'Yeni Destek Talebi',
      subjectLabel: 'Konu', categoryLabel: 'Kategori', descriptionLabel: 'Açıklama', priorityLabel: 'Öncelik',
      subjectPlaceholder: 'Sorununuzu kısaca özetleyin', descriptionPlaceholder: 'Sorununuzu detaylı açıklayın...',
      categoryTechnical: 'Teknik Sorun', categoryAccount: 'Hesap', categoryReport: 'Rapor', categoryOther: 'Diğer',
      priorityLow: 'Düşük', priorityNormal: 'Normal', priorityHigh: 'Yüksek',
      statusAll: 'Tümü', statusOpen: 'Açık', statusInProgress: 'İşlemde', statusResolved: 'Çözüldü', statusClosed: 'Kapatıldı',
      noTickets: 'Henüz destek talebiniz bulunmuyor', createFirst: 'İlk Talebinizi Oluşturun',
      submitBtn: 'Talep Oluştur', submitting: 'Oluşturuluyor...',
      replyPlaceholder: 'Yanıtınızı yazın...', sendReply: 'Gönder', images: 'görsel',
      deleteTicketConfirm: 'Bu talebi silmek istediğinize emin misiniz?',
      loadError: 'Talepler yüklenemedi', created: 'Destek talebi oluşturuldu', createError: 'Talep oluşturulamadı',
      subjectDescRequired: 'Konu ve açıklama zorunludur', deleted: 'Talep silindi', deleteError: 'Talep silinemedi',
      msgLoadError: 'Mesajlar yüklenemedi', msgSendError: 'Mesaj gönderilemedi',
      imageUploadError: 'Görsel yüklenemedi', deleteTitle: 'Talebi Sil',
      adminTitle: 'Destek Talepleri', allPriorities: 'Tüm Öncelikler',
      replyToUser: 'Kullanıcıya yanıt yazın...', urgent: 'Acil',
    },
  },

  // ══════════════════════════════════════════════════════
  // İNGİLİZCE
  // ══════════════════════════════════════════════════════
  en: {
    nav: {
      home: 'Home', whatWeDo: 'Features', about: 'About Us',
      blog: 'Blog', contact: 'Contact', login: 'Sign In',
      register: 'Sign Up Free', registerShort: 'Sign Up',
    },
    auth: {
      tabLogin: 'Sign In', tabRegister: 'Register', tabStore: 'Store Application',
      email: 'Email', password: 'Password', fullName: 'Full Name', phone: 'Phone',
      phoneOptional: 'Phone (optional)', passwordConfirm: 'Confirm Password',
      forgotPassword: 'Forgot password', forgotPasswordTitle: 'Forgot Password',
      forgotPasswordDesc: 'Enter your registered email address. We will send a password reset link.',
      emailAddress: 'Email Address', sendResetLink: 'Send Reset Link',
      sending: 'Sending...', emailSent: 'Email Sent!',
      emailSentDesc: 'if registered, a reset link was sent. Don\'t forget to check your spam folder.',
      backToLogin: '← Back to sign in',
      loginBtn: 'Sign In', loggingIn: 'Signing in...',
      registerBtn: 'Sign Up', registering: 'Creating account...',
      storeApply: 'Submit Application', storeApplying: 'Submitting...',
      googleLogin: 'Continue with Google', googleRegister: 'Sign up with Google',
      orWith: 'or', orWithEmail: 'or with email',
      storeName: 'Store Name', contactPerson: 'Contact Person', address: 'Address',
      termsConsent: 'I have read and accept the Terms of Use',
      kvkkConsent: 'I have read and accept the Privacy Policy',
      storeNote: 'Your application will be reviewed by the administrator and you will be notified upon approval.',
      sideHome: 'Home', sideAbout: 'About Us', sideContact: 'Contact',
    },
    landing: {
      aiBadge: 'AI-Powered Real Estate Reporting',
      watchDemo: 'Watch Demo',
      statReports: 'Reports Created',
      statConsultants: 'Active Consultants',
      statOffices: 'Real Estate Offices',
      featuresBadge: 'Features',
      featuresTitle: 'Everything in One Platform',
      featuresSubtitle: 'Tools that accelerate your workflows with a professional look',
      aiTitle: 'Professional Analysis',
      aiTitleGrad: 'in Seconds',
      aiTitleEnd: 'with AI',
      aiSubtitle: 'Let AI handle hours of market research and report writing. You just focus on your client.',
      aiGeminiBadge: 'Google Gemini AI Technology',
      aiStep: 'STEP',
      aiStep1Title: 'Data Entry',
      aiStep1Desc: 'Enter listing details, location and price range into the system',
      aiStep1Items: ['Address & Location', 'Sqm & Rooms', 'Price Range'],
      aiStep2Title: 'AI Analysis',
      aiStep2Desc: 'Gemini AI analyzes thousands of comparable listings and evaluates the market',
      aiStep2Items: ['Comparable Analysis', 'Market Analysis', 'Price Estimation'],
      aiStep3Title: 'Professional Report',
      aiStep3Desc: 'A branded, PDF-ready, shareable report is generated',
      aiStep3Items: ['Download PDF', 'Share via Link', 'Brand Identity'],
      aiFeatures: [
        { title: 'Automated Market Analysis', desc: 'Sales trends, price movements and market dynamics in the area are automatically analyzed.' },
        { title: 'Comparable Listing Comparison', desc: 'Similar listings are found and a detailed comparison table is created.' },
        { title: 'Smart Price Estimation', desc: 'Realistic price range calculated based on location, sqm and features.' },
        { title: 'Automated Report Writing', desc: 'All analyses are reported in professional language, no manual writing needed.' },
        { title: 'Ready in Seconds', desc: 'Analyses that take hours are completed in minutes thanks to AI.' },
        { title: 'Secure & Private', desc: 'All your data is stored encrypted, client privacy is fully protected.' },
      ],
      howBadge: 'How It Works', howTitle: 'Get Started in 3 Steps',
      howSubtitle: 'No setup required, ready in minutes',
      pricingBadge: 'Pricing', pricingTitle: 'Simple & Transparent',
      pricingSubtitle: 'No surprises, no hidden fees',
      pricingMonthly: '/month', pricingNoCard: 'No credit card required',
      pricingFreeAfter: 'Completely free after approval',
      pricingIndividual: 'Individual Consultant',
      pricingOffice: 'Real Estate Office',
      pricingIndividualFeatures: [
        'Unlimited report creation', 'High quality PDF download', 'Secure link sharing',
        'AI comparable analysis', 'Branded reports', 'Mobile-friendly panel', 'Technical support',
      ],
      pricingOfficeFeatures: [
        'All individual plan features', 'Office admin panel', 'Unlimited consultant accounts',
        'Consultant performance tracking', 'Access to all office reports', 'Office branded reports',
        'Custom logo & colors', 'Priority technical support',
      ],
      pricingStartFree: 'Get Started — Free',
      pricingApplyOffice: 'Apply for Office',
      testimonialsBadge: 'User Reviews',
      testimonialsTitle: 'What Consultants Say',
      testimonialsSubtitle: 'Trusted by thousands of professionals',
      faqBadge: 'FAQ', faqTitle: 'Frequently Asked\nQuestions',
      faqSubtitle: 'Find answers to everything you wonder about our platform.',
      faqNotFound: "Couldn't find an answer?", faqSupport: 'Our support team is available 24/7.',
      faqContactUs: 'Contact Us', faqResponseTime: 'Average response time: 2 hours',
      ctaTitle: 'Ready to Get Started?',
      ctaSubtitle: 'Create your free account and prepare your first report in minutes.',
      ctaBtn: 'Start Free',
      footerQuickAccess: 'Quick Links', footerContact: 'Contact',
      footerLinks: [['Home', '/'], ['About Us', '/hakkimizda'], ['Contact', '/iletisim'], ['Sign In', '/login']],
    },
    dashboard: {
      dashboard: 'Dashboard', reports: 'Reports', myReports: 'My Reports',
      listings: 'Listings', myListings: 'My Listings', newReport: 'New Report',
      users: 'Users', stores: 'Stores', apiKeys: 'API Keys',
      stats: 'Statistics', siteContent: 'Site Content', siteSettings: 'Site Settings',
      packages: 'Packages', contactMessages: 'Contact Messages',
      support: 'Support', supportTickets: 'Support Tickets',
      consultants: 'Consultants', myApiKey: 'My API Key', myStats: 'My Statistics',
      notifications: 'Notifications', profile: 'Profile', settings: 'Settings', logout: 'Sign Out',
    },
    common: {
      save: 'Save', cancel: 'Cancel', delete: 'Delete', edit: 'Edit', add: 'Add',
      search: 'Search', loading: 'Loading...', saving: 'Saving...', confirm: 'Confirm',
      close: 'Close', yes: 'Yes', no: 'No', actions: 'Actions', status: 'Status',
      date: 'Date', name: 'Name', email: 'Email', phone: 'Phone', back: 'Back',
      next: 'Next', submit: 'Submit', upload: 'Upload', download: 'Download', print: 'Print',
      preview: 'Preview', share: 'Share', copy: 'Copy', reset: 'Reset', refresh: 'Refresh',
      total: 'Total', active: 'Active', passive: 'Inactive', approved: 'Approved',
      pending: 'Pending', rejected: 'Rejected',
    },
    siteSettings: {
      languageTitle: 'Language Settings',
      languageDesc: 'Select the default language. Visitors can change the language at any time.',
      defaultLanguage: 'Default Site Language',
    },
    reports: {
      title: 'Reports', subtitle: 'View and manage all your reports',
      newReport: 'New Report', createNew: 'Create New Report',
      searchPlaceholder: 'Search by report name, consultant, customer...',
      selectMode: 'Select', deselectAll: 'Deselect All', selectAll: 'Select All',
      untitled: 'Untitled Report', archivedBadge: 'Archived',
      preparing: 'Preparing', pendingApproval: 'Pending Approval',
      readyForPresentation: 'Ready for Presentation', completed: 'Completed',
      consultant: 'Consultant', customer: 'Customer',
      restore: 'Restore', archiveTab: 'Archive',
      noReports: 'No reports yet', noArchived: 'No archived reports',
      archivedDesc: 'Archived reports appear here.', noResults: 'No results found',
      loadError: 'Could not load reports', deleted: 'Report deleted', deleteError: 'Could not delete report',
      archived: 'Report archived', archiveError: 'Archive failed',
      restored: 'Report restored', restoreError: 'Restore failed',
      pdfError: 'Could not create PDF', linkCopied: 'Share link copied!',
      linkError: 'Could not create link', statusUpdated: 'Status updated',
      statusError: 'Could not update status', bulkDeleted: 'reports deleted',
      bulkDeleteError: 'Some reports could not be deleted',
      deleteConfirmTitle: 'Are you sure you want to delete this report?',
      deleteConfirmDesc: 'This action cannot be undone. The report will be permanently deleted.',
      bulkDeleteConfirmDesc: 'This action cannot be undone. Selected reports will be permanently deleted.',
    },
    listings: {
      title: 'Listings', subtitle: 'Manage listings for monthly reporting',
      newListing: 'New Listing', searchPlaceholder: 'Search listings...',
      activeListings: 'Active Listings', archive: 'Archive',
      noListings: 'No listings added yet', noSearchResults: 'No listings match your search criteria.',
      noArchived: 'No archived listings', archivedListingsDesc: 'Deleted listings will appear here.',
      addFirstListing: 'Click "New Listing" to add your first listing.',
      noAssigned: 'No listings assigned to you.',
      editListing: 'Edit Listing', addListing: 'Add New Listing',
      titleLabel: 'Listing Title', priceLabel: 'Price', currencyLabel: 'Currency',
      platforms: 'Platform Listing Numbers', addPlatform: '+ Add Platform',
      platformName: 'Platform name (e.g. Zillow)', listingNo: 'Listing No',
      assignConsultant: 'Assign Consultant', unassigned: 'Unassigned',
      noConsultants: 'No consultants registered in the system',
      customerInfo: 'Customer Information (Optional)',
      customerName: 'Customer Name', customerPhone: 'Phone', customerEmail: 'Email',
      reportDate: 'Report Date', reportDateNote: 'A reminder will be sent to the consultant 7 days before this date.',
      notes: 'Notes', notesPlaceholder: 'Additional notes...',
      dialogDesc: 'Enter listing details. Consultant will be notified when assigned.',
      archivedBadge: 'Archived', archiveDate: 'Archived on',
      notDetermined: 'Not set', lastReport: 'Last Report',
      daysLeft: 'days left', overdue: 'Overdue', passive: 'Inactive',
      totalListings: 'Total Listings', activeCount: 'Active',
      upcomingReports: 'Reporting in 7 Days', delayedReports: 'Overdue',
      markedReported: 'Reported', restore: 'Restore', permanentDelete: 'Delete Permanently',
      sessionExpired: 'Session expired. Please log in again.',
      loadError: 'Could not load listings. Please refresh the page.',
      titlePriceRequired: 'Listing title and price are required',
      updated: 'Listing updated', created: 'Listing created', saveError: 'Could not save listing',
      archived: 'Listing moved to archive', archiveError: 'Could not archive listing',
      restored: 'Listing restored', restoreError: 'Could not restore listing',
      permanentlyDeleted: 'Listing permanently deleted', deleteError: 'Could not delete listing',
      markedReportedToast: 'Marked as reported. Next date: +30 days',
      undoReportedToast: 'Reported status undone',
      noConsultantAssigned: 'No consultant assigned to this listing',
      notifyError: 'Could not send notification', operationFailed: 'Operation failed',
      archiveConfirmTitle: 'Archive Listing',
      archiveConfirmDesc: 'Are you sure you want to archive this listing? You can restore it later.',
      permanentDeleteConfirmTitle: 'Delete Permanently',
      permanentDeleteConfirmDesc: 'Are you sure you want to permanently delete this listing? This cannot be undone.',
      noResults: 'No results found', consultantsLoading: 'Loading...',
    },
    users: {
      title: 'User Management', searchPlaceholder: 'Search by name or email...',
      total: 'Total', addedByAdmin: 'Added by Admin',
      newUser: 'New User', fullName: 'Full Name', emailLabel: 'Email',
      passwordLabel: 'Password', roleLabel: 'Role',
      usersTitle: 'Users',
      colUser: 'User', colRole: 'Role', colStatus: 'Status', colDuration: 'Duration', colActions: 'Actions',
      roleAll: 'All', roleSuperAdmin: 'Super Admin', roleStoreAdmin: 'Store Admin',
      roleConsultant: 'Consultant', roleIndividual: 'Individual User',
      roleSuperAdminLabel: 'Super Admin', roleStoreManagerLabel: 'Store Manager',
      roleConsultantLabel: 'Consultant', roleIndividualLabel: 'Individual',
      storeUser: 'Store User', individualUser: 'Individual User',
      editTitle: 'Edit User',
      newPassword: 'New Password (leave blank to keep unchanged)',
      newPasswordPlaceholder: 'Enter new password...',
      roleChangeNote: 'Role change takes effect on next login.',
      addDuration: 'Add Duration', durationTitle: 'Add Duration',
      durationSelect: 'Select Duration', currentExpiry: 'Current expiry date',
      durationNote: '* Added to current expiry. If past, starts from today.',
      manualDays: 'Manual Days', manualDaysPlaceholder: 'e.g. 45',
      durationBtn: 'Add Duration',
      active: 'Active', suspended: 'Suspended',
      deactivateTitle: 'Suspend', activateTitle: 'Activate',
      expired: 'Expired', daysLeft: 'd left',
      loadError: 'Could not load list', added: 'User added', error: 'An error occurred',
      deactivated: 'Account suspended', activated: 'Account activated',
      operationFailed: 'Operation failed', deleted: 'User deleted', deleteError: 'Delete failed',
      updated: 'User updated', updateFailed: 'Update failed',
      invalidDuration: 'Enter a valid duration', durationError: 'Could not add duration',
      durationAdded: 'days added. Expiry',
      deleteConfirm: 'Are you sure you want to delete this user?',
      googleRegistered: 'Registered with Google', adminAdded: 'Added by admin', emailRegistered: 'Registered with email',
    },
    support: {
      title: 'Support Center', subtitle: 'Report your issues and our team will help',
      newRequest: 'New Request', newTicketTitle: 'New Support Request',
      subjectLabel: 'Subject', categoryLabel: 'Category', descriptionLabel: 'Description', priorityLabel: 'Priority',
      subjectPlaceholder: 'Briefly describe your issue', descriptionPlaceholder: 'Describe your issue in detail...',
      categoryTechnical: 'Technical Issue', categoryAccount: 'Account', categoryReport: 'Report', categoryOther: 'Other',
      priorityLow: 'Low', priorityNormal: 'Normal', priorityHigh: 'High',
      statusAll: 'All', statusOpen: 'Open', statusInProgress: 'In Progress', statusResolved: 'Resolved', statusClosed: 'Closed',
      noTickets: 'No support requests yet', createFirst: 'Create Your First Request',
      submitBtn: 'Create Request', submitting: 'Creating...',
      replyPlaceholder: 'Write your reply...', sendReply: 'Send', images: 'image(s)',
      deleteTicketConfirm: 'Are you sure you want to delete this request?',
      loadError: 'Could not load requests', created: 'Support request created', createError: 'Could not create request',
      subjectDescRequired: 'Subject and description are required', deleted: 'Request deleted', deleteError: 'Could not delete request',
      msgLoadError: 'Could not load messages', msgSendError: 'Could not send message',
      imageUploadError: 'Could not upload image', deleteTitle: 'Delete Request',
      adminTitle: 'Support Tickets', allPriorities: 'All Priorities',
      replyToUser: 'Write a reply to the user...', urgent: 'Urgent',
    },
  },

  // ══════════════════════════════════════════════════════
  // ARAPÇA
  // ══════════════════════════════════════════════════════
  ar: {
    nav: {
      home: 'الرئيسية', whatWeDo: 'ما نفعله', about: 'من نحن',
      blog: 'المدونة', contact: 'اتصل بنا', login: 'تسجيل الدخول',
      register: 'التسجيل مجاناً', registerShort: 'تسجيل',
    },
    auth: {
      tabLogin: 'تسجيل الدخول', tabRegister: 'تسجيل فردي', tabStore: 'طلب متجر',
      email: 'البريد الإلكتروني', password: 'كلمة المرور', fullName: 'الاسم الكامل', phone: 'الهاتف',
      phoneOptional: 'الهاتف (اختياري)', passwordConfirm: 'تأكيد كلمة المرور',
      forgotPassword: 'نسيت كلمة المرور', forgotPasswordTitle: 'نسيت كلمة المرور',
      forgotPasswordDesc: 'أدخل بريدك الإلكتروني المسجل. سنرسل رابط إعادة تعيين كلمة المرور.',
      emailAddress: 'عنوان البريد الإلكتروني', sendResetLink: 'إرسال رابط الإعادة',
      sending: 'جارٍ الإرسال...', emailSent: 'تم إرسال البريد!',
      emailSentDesc: 'إذا كان مسجلاً، تم إرسال رابط الإعادة. لا تنسَ التحقق من مجلد الرسائل غير المرغوب فيها.',
      backToLogin: '← العودة إلى تسجيل الدخول',
      loginBtn: 'دخول', loggingIn: 'جارٍ الدخول...',
      registerBtn: 'تسجيل', registering: 'جارٍ التسجيل...',
      storeApply: 'إرسال الطلب', storeApplying: 'جارٍ الإرسال...',
      googleLogin: 'متابعة مع Google', googleRegister: 'التسجيل مع Google',
      orWith: 'أو', orWithEmail: 'أو عبر البريد الإلكتروني',
      storeName: 'اسم المتجر', contactPerson: 'جهة الاتصال', address: 'العنوان',
      termsConsent: 'لقد قرأت وأوافق على شروط الاستخدام',
      kvkkConsent: 'لقد قرأت وأوافق على سياسة الخصوصية',
      storeNote: 'سيتم مراجعة طلبك من قبل المسؤول وستتلقى إشعاراً عند الموافقة.',
      sideHome: 'الرئيسية', sideAbout: 'من نحن', sideContact: 'اتصل بنا',
    },
    landing: {
      aiBadge: 'تقارير عقارية بتقنية الذكاء الاصطناعي',
      watchDemo: 'مشاهدة العرض',
      statReports: 'تقرير تم إنشاؤه',
      statConsultants: 'مستشار نشط',
      statOffices: 'مكتب عقاري',
      featuresBadge: 'المميزات',
      featuresTitle: 'كل شيء في منصة واحدة',
      featuresSubtitle: 'أدوات تسرّع سير عملك بمظهر احترافي',
      aiTitle: 'تحليل احترافي',
      aiTitleGrad: 'في ثوانٍ',
      aiTitleEnd: 'بالذكاء الاصطناعي',
      aiSubtitle: 'دع الذكاء الاصطناعي يتولى ساعات من البحث وكتابة التقارير. أنت فقط ركّز على عميلك.',
      aiGeminiBadge: 'تقنية Google Gemini AI',
      aiStep: 'الخطوة',
      aiStep1Title: 'إدخال البيانات',
      aiStep1Desc: 'أدخل تفاصيل الإعلان والموقع ونطاق الأسعار في النظام',
      aiStep1Items: ['العنوان والموقع', 'المساحة والغرف', 'نطاق السعر'],
      aiStep2Title: 'تحليل AI',
      aiStep2Desc: 'يحلل Gemini AI آلاف الإعلانات المماثلة ويقيّم السوق',
      aiStep2Items: ['مقارنة الأمثال', 'تحليل السوق', 'تقدير السعر'],
      aiStep3Title: 'تقرير احترافي',
      aiStep3Desc: 'يتم إنشاء تقرير مُعلَّم بالعلامة التجارية وجاهز للمشاركة',
      aiStep3Items: ['تحميل PDF', 'المشاركة عبر رابط', 'هوية العلامة'],
      aiFeatures: [
        { title: 'تحليل السوق التلقائي', desc: 'يتم تحليل اتجاهات المبيعات وتحركات الأسعار وديناميكيات السوق تلقائياً.' },
        { title: 'مقارنة الإعلانات المماثلة', desc: 'يتم العثور على إعلانات مماثلة وإنشاء جدول مقارنة تفصيلي.' },
        { title: 'تقدير السعر الذكي', desc: 'يتم حساب نطاق سعر واقعي بناءً على الموقع والمساحة والمميزات.' },
        { title: 'كتابة التقارير التلقائية', desc: 'يتم تقديم جميع التحليلات بلغة احترافية دون الحاجة إلى الكتابة اليدوية.' },
        { title: 'جاهز في ثوانٍ', desc: 'تتم التحليلات التي تستغرق ساعات في دقائق بفضل الذكاء الاصطناعي.' },
        { title: 'آمن وخاص', desc: 'يتم تخزين جميع بياناتك بشكل مشفر مع حماية كاملة لخصوصية العميل.' },
      ],
      howBadge: 'كيف يعمل', howTitle: 'ابدأ في 3 خطوات',
      howSubtitle: 'لا يلزم الإعداد، جاهز في دقائق',
      pricingBadge: 'التسعير', pricingTitle: 'بسيط وشفاف',
      pricingSubtitle: 'لا مفاجآت، لا رسوم خفية',
      pricingMonthly: '/شهر', pricingNoCard: 'لا يلزم بطاقة ائتمان',
      pricingFreeAfter: 'مجاني تماماً بعد الموافقة',
      pricingIndividual: 'مستشار فردي',
      pricingOffice: 'مكتب عقاري',
      pricingIndividualFeatures: [
        'إنشاء تقارير غير محدود', 'تحميل PDF عالي الجودة', 'مشاركة رابط آمن',
        'تحليل AI للأمثال', 'تقارير بعلامتك التجارية', 'لوحة تحكم متوافقة مع الجوال', 'الدعم الفني',
      ],
      pricingOfficeFeatures: [
        'جميع مميزات الخطة الفردية', 'لوحة تحكم المكتب', 'حسابات مستشارين غير محدودة',
        'تتبع أداء المستشارين', 'الوصول لجميع تقارير المكتب', 'تقارير بعلامة المكتب التجارية',
        'شعار وألوان مخصصة', 'دعم فني ذو أولوية',
      ],
      pricingStartFree: 'ابدأ الآن — مجاناً',
      pricingApplyOffice: 'تقديم طلب المكتب',
      testimonialsBadge: 'آراء المستخدمين',
      testimonialsTitle: 'ماذا يقول المستشارون؟',
      testimonialsSubtitle: 'موثوق به من آلاف المحترفين',
      faqBadge: 'الأسئلة الشائعة', faqTitle: 'الأسئلة\nالشائعة',
      faqSubtitle: 'إجابات لكل ما تتساءل عنه حول منصتنا.',
      faqNotFound: 'لم تجد إجابة؟', faqSupport: 'فريق الدعم متاح على مدار الساعة.',
      faqContactUs: 'تواصل معنا', faqResponseTime: 'متوسط وقت الاستجابة: ساعتان',
      ctaTitle: 'هل أنت مستعد للبدء؟',
      ctaSubtitle: 'أنشئ حسابك المجاني وأعد تقريرك الأول في دقائق.',
      ctaBtn: 'ابدأ مجاناً',
      footerQuickAccess: 'روابط سريعة', footerContact: 'اتصل بنا',
      footerLinks: [['الرئيسية', '/'], ['من نحن', '/hakkimizda'], ['اتصل بنا', '/iletisim'], ['تسجيل الدخول', '/login']],
    },
    dashboard: {
      dashboard: 'لوحة التحكم', reports: 'التقارير', myReports: 'تقاريري',
      listings: 'الإعلانات', myListings: 'إعلاناتي', newReport: 'تقرير جديد',
      users: 'المستخدمون', stores: 'المتاجر', apiKeys: 'مفاتيح API',
      stats: 'الإحصائيات', siteContent: 'محتوى الموقع', siteSettings: 'إعدادات الموقع',
      packages: 'الباقات', contactMessages: 'رسائل التواصل',
      support: 'الدعم', supportTickets: 'تذاكر الدعم',
      consultants: 'المستشارون', myApiKey: 'مفتاح API الخاص بي', myStats: 'إحصائياتي',
      notifications: 'الإشعارات', profile: 'الملف الشخصي', settings: 'الإعدادات', logout: 'تسجيل الخروج',
    },
    common: {
      save: 'حفظ', cancel: 'إلغاء', delete: 'حذف', edit: 'تعديل', add: 'إضافة',
      search: 'بحث', loading: 'جارٍ التحميل...', saving: 'جارٍ الحفظ...', confirm: 'تأكيد',
      close: 'إغلاق', yes: 'نعم', no: 'لا', actions: 'الإجراءات', status: 'الحالة',
      date: 'التاريخ', name: 'الاسم', email: 'البريد الإلكتروني', phone: 'الهاتف', back: 'رجوع',
      next: 'التالي', submit: 'إرسال', upload: 'رفع', download: 'تحميل', print: 'طباعة',
      preview: 'معاينة', share: 'مشاركة', copy: 'نسخ', reset: 'إعادة تعيين', refresh: 'تحديث',
      total: 'المجموع', active: 'نشط', passive: 'غير نشط', approved: 'موافق عليه',
      pending: 'قيد الانتظار', rejected: 'مرفوض',
    },
    siteSettings: {
      languageTitle: 'إعدادات اللغة',
      languageDesc: 'اختر اللغة الافتراضية للموقع. يمكن للزوار تغيير اللغة في أي وقت.',
      defaultLanguage: 'اللغة الافتراضية للموقع',
    },
    reports: {
      title: 'التقارير', subtitle: 'عرض وإدارة جميع تقاريرك',
      newReport: 'تقرير جديد', createNew: 'إنشاء تقرير جديد',
      searchPlaceholder: 'البحث باسم التقرير أو المستشار أو العميل...',
      selectMode: 'تحديد', deselectAll: 'إلغاء التحديد', selectAll: 'تحديد الكل',
      untitled: 'تقرير بلا عنوان', archivedBadge: 'مؤرشف',
      preparing: 'قيد الإعداد', pendingApproval: 'بانتظار الموافقة',
      readyForPresentation: 'جاهز للعرض', completed: 'مكتمل',
      consultant: 'المستشار', customer: 'العميل',
      restore: 'استعادة', archiveTab: 'الأرشيف',
      noReports: 'لا توجد تقارير بعد', noArchived: 'لا يوجد أرشيف',
      archivedDesc: 'التقارير المؤرشفة تظهر هنا.', noResults: 'لا نتائج',
      loadError: 'تعذّر تحميل التقارير', deleted: 'تم حذف التقرير', deleteError: 'تعذّر الحذف',
      archived: 'تم أرشفة التقرير', archiveError: 'فشل الأرشفة',
      restored: 'تمت استعادة التقرير', restoreError: 'فشل الاستعادة',
      pdfError: 'تعذّر إنشاء PDF', linkCopied: 'تم نسخ رابط المشاركة!',
      linkError: 'تعذّر إنشاء الرابط', statusUpdated: 'تم تحديث الحالة',
      statusError: 'تعذّر تحديث الحالة', bulkDeleted: 'تقرير محذوف',
      bulkDeleteError: 'تعذّر حذف بعض التقارير',
      deleteConfirmTitle: 'هل أنت متأكد من حذف هذا التقرير؟',
      deleteConfirmDesc: 'لا يمكن التراجع عن هذا. سيتم حذف التقرير نهائياً.',
      bulkDeleteConfirmDesc: 'لا يمكن التراجع عن هذا. سيتم حذف التقارير المحددة نهائياً.',
    },
    listings: {
      title: 'الإعلانات', subtitle: 'إدارة الإعلانات للتقارير الشهرية',
      newListing: 'إعلان جديد', searchPlaceholder: 'البحث في الإعلانات...',
      activeListings: 'الإعلانات النشطة', archive: 'الأرشيف',
      noListings: 'لم يتم إضافة إعلانات بعد', noSearchResults: 'لا إعلانات تطابق بحثك.',
      noArchived: 'لا توجد إعلانات مؤرشفة', archivedListingsDesc: 'الإعلانات المحذوفة ستظهر هنا.',
      addFirstListing: 'انقر على "إعلان جديد" لإضافة أول إعلان.',
      noAssigned: 'لا توجد إعلانات معيّنة لك.',
      editListing: 'تعديل الإعلان', addListing: 'إضافة إعلان جديد',
      titleLabel: 'عنوان الإعلان', priceLabel: 'السعر', currencyLabel: 'العملة',
      platforms: 'أرقام الإعلانات على المنصات', addPlatform: '+ إضافة منصة',
      platformName: 'اسم المنصة', listingNo: 'رقم الإعلان',
      assignConsultant: 'تعيين مستشار', unassigned: 'غير معيّن',
      noConsultants: 'لا يوجد مستشارون في النظام',
      customerInfo: 'معلومات العميل (اختياري)',
      customerName: 'اسم العميل', customerPhone: 'الهاتف', customerEmail: 'البريد الإلكتروني',
      reportDate: 'تاريخ التقرير', reportDateNote: 'سيتم إرسال تذكير للمستشار قبل 7 أيام.',
      notes: 'ملاحظات', notesPlaceholder: 'ملاحظات إضافية...',
      dialogDesc: 'أدخل تفاصيل الإعلان.',
      archivedBadge: 'مؤرشف', archiveDate: 'تاريخ الأرشفة',
      notDetermined: 'غير محدد', lastReport: 'آخر تقرير',
      daysLeft: 'يوم متبقي', overdue: 'متأخر', passive: 'غير نشط',
      totalListings: 'إجمالي الإعلانات', activeCount: 'نشط',
      upcomingReports: 'تقارير خلال 7 أيام', delayedReports: 'متأخر',
      markedReported: 'تم التقرير', restore: 'استعادة', permanentDelete: 'حذف نهائي',
      sessionExpired: 'انتهت الجلسة. يرجى تسجيل الدخول مجدداً.',
      loadError: 'تعذّر تحميل الإعلانات.', titlePriceRequired: 'العنوان والسعر مطلوبان',
      updated: 'تم تحديث الإعلان', created: 'تم إنشاء الإعلان', saveError: 'تعذّر حفظ الإعلان',
      archived: 'تم نقل الإعلان للأرشيف', archiveError: 'تعذّر الأرشفة',
      restored: 'تمت استعادة الإعلان', restoreError: 'تعذّر الاستعادة',
      permanentlyDeleted: 'تم حذف الإعلان نهائياً', deleteError: 'تعذّر الحذف',
      markedReportedToast: 'تم وضع علامة مُبلَّغ. التالي: +30 يوم',
      undoReportedToast: 'تم التراجع عن حالة التقرير',
      noConsultantAssigned: 'لم يتم تعيين مستشار لهذا الإعلان',
      notifyError: 'تعذّر إرسال الإشعار', operationFailed: 'فشلت العملية',
      archiveConfirmTitle: 'أرشفة الإعلان',
      archiveConfirmDesc: 'هل تريد نقل الإعلان للأرشيف؟ يمكنك استعادته لاحقاً.',
      permanentDeleteConfirmTitle: 'حذف نهائي',
      permanentDeleteConfirmDesc: 'هل تريد الحذف النهائي؟ لا يمكن التراجع.',
      noResults: 'لا نتائج', consultantsLoading: 'جارٍ التحميل...',
    },
    users: {
      title: 'إدارة المستخدمين', searchPlaceholder: 'البحث بالاسم أو البريد...',
      total: 'المجموع', addedByAdmin: 'أضافه المشرف',
      newUser: 'مستخدم جديد', fullName: 'الاسم الكامل', emailLabel: 'البريد الإلكتروني',
      passwordLabel: 'كلمة المرور', roleLabel: 'الدور',
      usersTitle: 'المستخدمون',
      colUser: 'المستخدم', colRole: 'الدور', colStatus: 'الحالة', colDuration: 'المدة', colActions: 'الإجراءات',
      roleAll: 'الكل', roleSuperAdmin: 'مشرف عام', roleStoreAdmin: 'مشرف متجر',
      roleConsultant: 'مستشار', roleIndividual: 'مستخدم فردي',
      roleSuperAdminLabel: 'مشرف عام', roleStoreManagerLabel: 'مدير المتجر',
      roleConsultantLabel: 'مستشار', roleIndividualLabel: 'فردي',
      storeUser: 'مستخدم المتجر', individualUser: 'مستخدم فردي',
      editTitle: 'تعديل المستخدم',
      newPassword: 'كلمة مرور جديدة (اتركها فارغة للإبقاء)',
      newPasswordPlaceholder: 'أدخل كلمة المرور الجديدة...',
      roleChangeNote: 'تغيير الدور يسري عند تسجيل الدخول التالي.',
      addDuration: 'إضافة مدة', durationTitle: 'إضافة مدة',
      durationSelect: 'اختر المدة', currentExpiry: 'تاريخ انتهاء الصلاحية الحالي',
      durationNote: '* يضاف إلى الصلاحية الحالية. إذا انتهت، تبدأ من اليوم.',
      manualDays: 'أيام يدوية', manualDaysPlaceholder: 'مثال: 45',
      durationBtn: 'إضافة مدة',
      active: 'نشط', suspended: 'موقوف',
      deactivateTitle: 'إيقاف', activateTitle: 'تفعيل',
      expired: 'انتهت الصلاحية', daysLeft: 'ي متبقي',
      loadError: 'تعذّر تحميل القائمة', added: 'تمت إضافة المستخدم', error: 'حدث خطأ',
      deactivated: 'تم إيقاف الحساب', activated: 'تم تفعيل الحساب',
      operationFailed: 'فشلت العملية', deleted: 'تم حذف المستخدم', deleteError: 'فشل الحذف',
      updated: 'تم تحديث المستخدم', updateFailed: 'فشل التحديث',
      invalidDuration: 'أدخل مدة صالحة', durationError: 'تعذّر إضافة المدة',
      durationAdded: 'يوم مضاف. الانتهاء',
      deleteConfirm: 'هل تريد حذف هذا المستخدم؟',
      googleRegistered: 'مسجل بـ Google', adminAdded: 'أضافه المشرف', emailRegistered: 'مسجل بالبريد',
    },
    support: {
      title: 'مركز الدعم', subtitle: 'أبلغ عن مشاكلك وسيساعدك فريقنا',
      newRequest: 'طلب جديد', newTicketTitle: 'طلب دعم جديد',
      subjectLabel: 'الموضوع', categoryLabel: 'الفئة', descriptionLabel: 'الوصف', priorityLabel: 'الأولوية',
      subjectPlaceholder: 'لخّص مشكلتك باختصار', descriptionPlaceholder: 'اشرح مشكلتك بالتفصيل...',
      categoryTechnical: 'مشكلة تقنية', categoryAccount: 'الحساب', categoryReport: 'تقرير', categoryOther: 'أخرى',
      priorityLow: 'منخفض', priorityNormal: 'عادي', priorityHigh: 'عالٍ',
      statusAll: 'الكل', statusOpen: 'مفتوح', statusInProgress: 'قيد المعالجة', statusResolved: 'تم الحل', statusClosed: 'مغلق',
      noTickets: 'لا توجد طلبات دعم بعد', createFirst: 'أنشئ أول طلب',
      submitBtn: 'إنشاء طلب', submitting: 'جارٍ الإنشاء...',
      replyPlaceholder: 'اكتب ردك...', sendReply: 'إرسال', images: 'صورة',
      deleteTicketConfirm: 'هل تريد حذف هذا الطلب؟',
      loadError: 'تعذّر تحميل الطلبات', created: 'تم إنشاء طلب الدعم', createError: 'تعذّر إنشاء الطلب',
      subjectDescRequired: 'الموضوع والوصف مطلوبان', deleted: 'تم حذف الطلب', deleteError: 'تعذّر الحذف',
      msgLoadError: 'تعذّر تحميل الرسائل', msgSendError: 'تعذّر إرسال الرسالة',
      imageUploadError: 'تعذّر رفع الصورة', deleteTitle: 'حذف الطلب',
      adminTitle: 'تذاكر الدعم', allPriorities: 'كل الأولويات',
      replyToUser: 'اكتب رداً للمستخدم...', urgent: 'عاجل',
    },
  },

  // ══════════════════════════════════════════════════════
  // RUSÇA
  // ══════════════════════════════════════════════════════
  ru: {
    nav: {
      home: 'Главная', whatWeDo: 'Что мы делаем', about: 'О нас',
      blog: 'Блог', contact: 'Контакты', login: 'Войти',
      register: 'Регистрация бесплатно', registerShort: 'Регистрация',
    },
    auth: {
      tabLogin: 'Войти', tabRegister: 'Регистрация', tabStore: 'Заявка на магазин',
      email: 'Электронная почта', password: 'Пароль', fullName: 'Полное имя', phone: 'Телефон',
      phoneOptional: 'Телефон (необязательно)', passwordConfirm: 'Подтвердите пароль',
      forgotPassword: 'Забыли пароль', forgotPasswordTitle: 'Забыли пароль',
      forgotPasswordDesc: 'Введите зарегистрированный адрес электронной почты. Мы отправим ссылку для сброса пароля.',
      emailAddress: 'Адрес электронной почты', sendResetLink: 'Отправить ссылку',
      sending: 'Отправка...', emailSent: 'Письмо отправлено!',
      emailSentDesc: 'если зарегистрирован, ссылка отправлена. Проверьте папку со спамом.',
      backToLogin: '← Вернуться к входу',
      loginBtn: 'Войти', loggingIn: 'Вход...',
      registerBtn: 'Зарегистрироваться', registering: 'Регистрация...',
      storeApply: 'Отправить заявку', storeApplying: 'Отправка...',
      googleLogin: 'Продолжить с Google', googleRegister: 'Зарегистрироваться с Google',
      orWith: 'или', orWithEmail: 'или через почту',
      storeName: 'Название магазина', contactPerson: 'Контактное лицо', address: 'Адрес',
      termsConsent: 'Я прочитал и принимаю Условия использования',
      kvkkConsent: 'Я прочитал и принимаю Политику конфиденциальности',
      storeNote: 'Ваша заявка будет рассмотрена администратором, вы получите уведомление после одобрения.',
      sideHome: 'Главная', sideAbout: 'О нас', sideContact: 'Контакты',
    },
    landing: {
      aiBadge: 'Отчётность по недвижимости с ИИ',
      watchDemo: 'Смотреть демо',
      statReports: 'Отчётов создано',
      statConsultants: 'Активных консультантов',
      statOffices: 'Агентств недвижимости',
      featuresBadge: 'Возможности',
      featuresTitle: 'Всё в одной платформе',
      featuresSubtitle: 'Инструменты для ускорения рабочих процессов с профессиональным видом',
      aiTitle: 'Профессиональный анализ',
      aiTitleGrad: 'за секунды',
      aiTitleEnd: 'с ИИ',
      aiSubtitle: 'Поручите ИИ часы исследований и написания отчётов. Вы просто сосредоточьтесь на клиенте.',
      aiGeminiBadge: 'Технология Google Gemini AI',
      aiStep: 'ШАГ',
      aiStep1Title: 'Ввод данных',
      aiStep1Desc: 'Введите информацию об объявлении, местоположение и ценовой диапазон',
      aiStep1Items: ['Адрес и местоположение', 'Площадь и комнаты', 'Ценовой диапазон'],
      aiStep2Title: 'Анализ ИИ',
      aiStep2Desc: 'Gemini AI анализирует тысячи сопоставимых объявлений и оценивает рынок',
      aiStep2Items: ['Сравнение аналогов', 'Анализ рынка', 'Оценка цены'],
      aiStep3Title: 'Профессиональный отчёт',
      aiStep3Desc: 'Создаётся брендированный, готовый к печати и публикации отчёт',
      aiStep3Items: ['Скачать PDF', 'Поделиться ссылкой', 'Фирменный стиль'],
      aiFeatures: [
        { title: 'Автоматический анализ рынка', desc: 'Тенденции продаж, движения цен и рыночная динамика в районе анализируются автоматически.' },
        { title: 'Сравнение аналогичных объявлений', desc: 'Находятся похожие объявления и создаётся детальная таблица сравнения.' },
        { title: 'Умная оценка цены', desc: 'Рассчитывается реалистичный ценовой диапазон на основе местоположения, площади и характеристик.' },
        { title: 'Автоматическое написание отчётов', desc: 'Все анализы представляются профессиональным языком без ручного написания.' },
        { title: 'Готово за секунды', desc: 'Анализы, занимающие часы, выполняются за минуты благодаря ИИ.' },
        { title: 'Безопасно и конфиденциально', desc: 'Все ваши данные хранятся в зашифрованном виде, конфиденциальность клиентов полностью защищена.' },
      ],
      howBadge: 'Как это работает', howTitle: 'Начните за 3 шага',
      howSubtitle: 'Не требует настройки, готово за минуты',
      pricingBadge: 'Цены', pricingTitle: 'Просто и прозрачно',
      pricingSubtitle: 'Никаких сюрпризов, никаких скрытых платежей',
      pricingMonthly: '/мес', pricingNoCard: 'Кредитная карта не нужна',
      pricingFreeAfter: 'Полностью бесплатно после одобрения',
      pricingIndividual: 'Индивидуальный консультант',
      pricingOffice: 'Агентство недвижимости',
      pricingIndividualFeatures: [
        'Неограниченное создание отчётов', 'Скачивание PDF высокого качества', 'Безопасный обмен ссылками',
        'ИИ-анализ аналогов', 'Фирменные отчёты', 'Мобильная панель управления', 'Техническая поддержка',
      ],
      pricingOfficeFeatures: [
        'Все функции индивидуального плана', 'Панель администратора офиса', 'Неограниченные аккаунты консультантов',
        'Отслеживание производительности консультантов', 'Доступ ко всем отчётам офиса', 'Фирменные отчёты офиса',
        'Пользовательский логотип и цвета', 'Приоритетная техническая поддержка',
      ],
      pricingStartFree: 'Начать — Бесплатно',
      pricingApplyOffice: 'Подать заявку для офиса',
      testimonialsBadge: 'Отзывы пользователей',
      testimonialsTitle: 'Что говорят консультанты?',
      testimonialsSubtitle: 'Которому доверяют тысячи профессионалов',
      faqBadge: 'FAQ', faqTitle: 'Часто задаваемые\nвопросы',
      faqSubtitle: 'Ответы на всё, что вас интересует о нашей платформе.',
      faqNotFound: 'Не нашли ответ?', faqSupport: 'Наша служба поддержки доступна 24/7.',
      faqContactUs: 'Связаться с нами', faqResponseTime: 'Среднее время ответа: 2 часа',
      ctaTitle: 'Готовы начать?',
      ctaSubtitle: 'Создайте бесплатный аккаунт и подготовьте первый отчёт за минуты.',
      ctaBtn: 'Начать бесплатно',
      footerQuickAccess: 'Быстрые ссылки', footerContact: 'Контакты',
      footerLinks: [['Главная', '/'], ['О нас', '/hakkimizda'], ['Контакты', '/iletisim'], ['Войти', '/login']],
    },
    dashboard: {
      dashboard: 'Панель управления', reports: 'Отчёты', myReports: 'Мои отчёты',
      listings: 'Объявления', myListings: 'Мои объявления', newReport: 'Новый отчёт',
      users: 'Пользователи', stores: 'Магазины', apiKeys: 'API ключи',
      stats: 'Статистика', siteContent: 'Контент сайта', siteSettings: 'Настройки сайта',
      packages: 'Пакеты', contactMessages: 'Сообщения',
      support: 'Поддержка', supportTickets: 'Тикеты поддержки',
      consultants: 'Консультанты', myApiKey: 'Мой API ключ', myStats: 'Моя статистика',
      notifications: 'Уведомления', profile: 'Профиль', settings: 'Настройки', logout: 'Выйти',
    },
    common: {
      save: 'Сохранить', cancel: 'Отмена', delete: 'Удалить', edit: 'Редактировать', add: 'Добавить',
      search: 'Поиск', loading: 'Загрузка...', saving: 'Сохранение...', confirm: 'Подтвердить',
      close: 'Закрыть', yes: 'Да', no: 'Нет', actions: 'Действия', status: 'Статус',
      date: 'Дата', name: 'Имя', email: 'Электронная почта', phone: 'Телефон', back: 'Назад',
      next: 'Далее', submit: 'Отправить', upload: 'Загрузить', download: 'Скачать', print: 'Печать',
      preview: 'Предпросмотр', share: 'Поделиться', copy: 'Копировать', reset: 'Сбросить', refresh: 'Обновить',
      total: 'Итого', active: 'Активный', passive: 'Неактивный', approved: 'Одобрен',
      pending: 'Ожидает', rejected: 'Отклонён',
    },
    siteSettings: {
      languageTitle: 'Настройки языка',
      languageDesc: 'Выберите язык по умолчанию. Посетители могут изменить язык в любое время.',
      defaultLanguage: 'Язык сайта по умолчанию',
    },
    reports: {
      title: 'Отчёты', subtitle: 'Просматривайте и управляйте всеми отчётами',
      newReport: 'Новый отчёт', createNew: 'Создать отчёт',
      searchPlaceholder: 'Поиск по отчёту, консультанту, клиенту...',
      selectMode: 'Выбрать', deselectAll: 'Снять выбор', selectAll: 'Выбрать всё',
      untitled: 'Без названия', archivedBadge: 'Архивировано',
      preparing: 'Подготовка', pendingApproval: 'Ожидает одобрения',
      readyForPresentation: 'Готов к презентации', completed: 'Завершён',
      consultant: 'Консультант', customer: 'Клиент',
      restore: 'Восстановить', archiveTab: 'Архив',
      noReports: 'Нет отчётов', noArchived: 'Нет архивных отчётов',
      archivedDesc: 'Архивные отчёты появятся здесь.', noResults: 'Нет результатов',
      loadError: 'Не удалось загрузить отчёты', deleted: 'Отчёт удалён', deleteError: 'Не удалось удалить',
      archived: 'Отчёт архивирован', archiveError: 'Ошибка архивации',
      restored: 'Отчёт восстановлен', restoreError: 'Ошибка восстановления',
      pdfError: 'Не удалось создать PDF', linkCopied: 'Ссылка скопирована!',
      linkError: 'Не удалось создать ссылку', statusUpdated: 'Статус обновлён',
      statusError: 'Не удалось обновить статус', bulkDeleted: 'отчётов удалено',
      bulkDeleteError: 'Не все отчёты удалены',
      deleteConfirmTitle: 'Удалить этот отчёт?',
      deleteConfirmDesc: 'Это действие нельзя отменить. Отчёт будет удалён навсегда.',
      bulkDeleteConfirmDesc: 'Это действие нельзя отменить. Выбранные отчёты будут удалены навсегда.',
    },
    listings: {
      title: 'Объявления', subtitle: 'Управление объявлениями для ежемесячных отчётов',
      newListing: 'Новое объявление', searchPlaceholder: 'Поиск объявлений...',
      activeListings: 'Активные объявления', archive: 'Архив',
      noListings: 'Нет объявлений', noSearchResults: 'Нет объявлений по запросу.',
      noArchived: 'Нет архивных объявлений', archivedListingsDesc: 'Удалённые объявления появятся здесь.',
      addFirstListing: 'Нажмите "Новое объявление" для добавления.',
      noAssigned: 'Нет назначенных объявлений.',
      editListing: 'Редактировать объявление', addListing: 'Добавить объявление',
      titleLabel: 'Заголовок', priceLabel: 'Цена', currencyLabel: 'Валюта',
      platforms: 'Номера объявлений на платформах', addPlatform: '+ Платформа',
      platformName: 'Название платформы', listingNo: '№ объявления',
      assignConsultant: 'Назначить консультанта', unassigned: 'Не назначен',
      noConsultants: 'Нет консультантов в системе',
      customerInfo: 'Данные клиента (необязательно)',
      customerName: 'Имя клиента', customerPhone: 'Телефон', customerEmail: 'Email',
      reportDate: 'Дата отчёта', reportDateNote: 'Напоминание консультанту за 7 дней.',
      notes: 'Заметки', notesPlaceholder: 'Дополнительные заметки...',
      dialogDesc: 'Введите данные объявления.',
      archivedBadge: 'Архивировано', archiveDate: 'Дата архивации',
      notDetermined: 'Не задано', lastReport: 'Последний отчёт',
      daysLeft: 'дн. осталось', overdue: 'Просрочено', passive: 'Неактивно',
      totalListings: 'Всего объявлений', activeCount: 'Активных',
      upcomingReports: 'Отчёты в 7 дней', delayedReports: 'Просрочено',
      markedReported: 'Отчитаться', restore: 'Восстановить', permanentDelete: 'Удалить навсегда',
      sessionExpired: 'Сессия истекла. Войдите снова.',
      loadError: 'Не удалось загрузить объявления.', titlePriceRequired: 'Заголовок и цена обязательны',
      updated: 'Объявление обновлено', created: 'Объявление создано', saveError: 'Не удалось сохранить',
      archived: 'Объявление в архиве', archiveError: 'Ошибка архивации',
      restored: 'Объявление восстановлено', restoreError: 'Ошибка восстановления',
      permanentlyDeleted: 'Объявление удалено навсегда', deleteError: 'Не удалось удалить',
      markedReportedToast: 'Отмечено как отчитанное. Следующее: +30 дней',
      undoReportedToast: 'Статус отчёта отменён',
      noConsultantAssigned: 'Консультант не назначен',
      notifyError: 'Не удалось отправить уведомление', operationFailed: 'Ошибка операции',
      archiveConfirmTitle: 'Архивировать объявление',
      archiveConfirmDesc: 'Архивировать объявление? Его можно восстановить позже.',
      permanentDeleteConfirmTitle: 'Удалить навсегда',
      permanentDeleteConfirmDesc: 'Удалить навсегда? Это нельзя отменить.',
      noResults: 'Нет результатов', consultantsLoading: 'Загрузка...',
    },
    users: {
      title: 'Управление пользователями', searchPlaceholder: 'Поиск по имени или email...',
      total: 'Всего', addedByAdmin: 'Добавлен администратором',
      newUser: 'Новый пользователь', fullName: 'Полное имя', emailLabel: 'Email',
      passwordLabel: 'Пароль', roleLabel: 'Роль',
      usersTitle: 'Пользователи',
      colUser: 'Пользователь', colRole: 'Роль', colStatus: 'Статус', colDuration: 'Срок', colActions: 'Действия',
      roleAll: 'Все', roleSuperAdmin: 'Супер-администратор', roleStoreAdmin: 'Администратор магазина',
      roleConsultant: 'Консультант', roleIndividual: 'Индивидуальный',
      roleSuperAdminLabel: 'Супер-администратор', roleStoreManagerLabel: 'Менеджер магазина',
      roleConsultantLabel: 'Консультант', roleIndividualLabel: 'Индивидуальный',
      storeUser: 'Пользователь магазина', individualUser: 'Индивидуальный пользователь',
      editTitle: 'Редактировать пользователя',
      newPassword: 'Новый пароль (оставьте пустым для сохранения)',
      newPasswordPlaceholder: 'Введите новый пароль...',
      roleChangeNote: 'Изменение роли вступит в силу при следующем входе.',
      addDuration: 'Добавить срок', durationTitle: 'Добавить срок',
      durationSelect: 'Выберите срок', currentExpiry: 'Текущая дата истечения',
      durationNote: '* Добавляется к текущему сроку. Если истёк — с сегодня.',
      manualDays: 'Ручные дни', manualDaysPlaceholder: 'Напр: 45',
      durationBtn: 'Добавить срок',
      active: 'Активен', suspended: 'Приостановлен',
      deactivateTitle: 'Приостановить', activateTitle: 'Активировать',
      expired: 'Срок истёк', daysLeft: 'д. осталось',
      loadError: 'Не удалось загрузить список', added: 'Пользователь добавлен', error: 'Произошла ошибка',
      deactivated: 'Аккаунт приостановлен', activated: 'Аккаунт активирован',
      operationFailed: 'Ошибка операции', deleted: 'Пользователь удалён', deleteError: 'Ошибка удаления',
      updated: 'Пользователь обновлён', updateFailed: 'Ошибка обновления',
      invalidDuration: 'Введите корректный срок', durationError: 'Не удалось добавить срок',
      durationAdded: 'дней добавлено. Истекает',
      deleteConfirm: 'Удалить этого пользователя?',
      googleRegistered: 'Зарегистрирован через Google', adminAdded: 'Добавлен администратором', emailRegistered: 'Email-регистрация',
    },
    support: {
      title: 'Центр поддержки', subtitle: 'Сообщайте о проблемах — мы поможем',
      newRequest: 'Новый запрос', newTicketTitle: 'Новый запрос в поддержку',
      subjectLabel: 'Тема', categoryLabel: 'Категория', descriptionLabel: 'Описание', priorityLabel: 'Приоритет',
      subjectPlaceholder: 'Кратко опишите проблему', descriptionPlaceholder: 'Подробно опишите проблему...',
      categoryTechnical: 'Техническая проблема', categoryAccount: 'Аккаунт', categoryReport: 'Отчёт', categoryOther: 'Другое',
      priorityLow: 'Низкий', priorityNormal: 'Нормальный', priorityHigh: 'Высокий',
      statusAll: 'Все', statusOpen: 'Открыт', statusInProgress: 'В работе', statusResolved: 'Решён', statusClosed: 'Закрыт',
      noTickets: 'Нет запросов в поддержку', createFirst: 'Создайте первый запрос',
      submitBtn: 'Создать запрос', submitting: 'Создание...',
      replyPlaceholder: 'Напишите ответ...', sendReply: 'Отправить', images: 'изобр.',
      deleteTicketConfirm: 'Удалить этот запрос?',
      loadError: 'Не удалось загрузить запросы', created: 'Запрос создан', createError: 'Не удалось создать запрос',
      subjectDescRequired: 'Тема и описание обязательны', deleted: 'Запрос удалён', deleteError: 'Не удалось удалить',
      msgLoadError: 'Не удалось загрузить сообщения', msgSendError: 'Не удалось отправить сообщение',
      imageUploadError: 'Не удалось загрузить изображение', deleteTitle: 'Удалить запрос',
      adminTitle: 'Тикеты поддержки', allPriorities: 'Все приоритеты',
      replyToUser: 'Напишите ответ пользователю...', urgent: 'Срочно',
    },
  },

  // ══════════════════════════════════════════════════════
  // ALMANCA
  // ══════════════════════════════════════════════════════
  de: {
    nav: {
      home: 'Startseite', whatWeDo: 'Was wir tun', about: 'Über uns',
      blog: 'Blog', contact: 'Kontakt', login: 'Anmelden',
      register: 'Kostenlos registrieren', registerShort: 'Registrieren',
    },
    auth: {
      tabLogin: 'Anmelden', tabRegister: 'Registrieren', tabStore: 'Shop-Bewerbung',
      email: 'E-Mail', password: 'Passwort', fullName: 'Vollständiger Name', phone: 'Telefon',
      phoneOptional: 'Telefon (optional)', passwordConfirm: 'Passwort bestätigen',
      forgotPassword: 'Passwort vergessen', forgotPasswordTitle: 'Passwort vergessen',
      forgotPasswordDesc: 'Geben Sie Ihre registrierte E-Mail-Adresse ein. Wir senden einen Passwort-Reset-Link.',
      emailAddress: 'E-Mail-Adresse', sendResetLink: 'Reset-Link senden',
      sending: 'Wird gesendet...', emailSent: 'E-Mail gesendet!',
      emailSentDesc: 'Wenn registriert, wurde ein Reset-Link gesendet. Vergessen Sie nicht, Ihren Spam-Ordner zu prüfen.',
      backToLogin: '← Zurück zur Anmeldung',
      loginBtn: 'Anmelden', loggingIn: 'Anmeldung läuft...',
      registerBtn: 'Registrieren', registering: 'Registrierung...',
      storeApply: 'Bewerbung senden', storeApplying: 'Wird gesendet...',
      googleLogin: 'Mit Google fortfahren', googleRegister: 'Mit Google registrieren',
      orWith: 'oder', orWithEmail: 'oder per E-Mail',
      storeName: 'Shop-Name', contactPerson: 'Ansprechpartner', address: 'Adresse',
      termsConsent: 'Ich habe die Nutzungsbedingungen gelesen und akzeptiert',
      kvkkConsent: 'Ich habe die Datenschutzrichtlinie gelesen und akzeptiert',
      storeNote: 'Ihre Bewerbung wird vom Administrator geprüft und Sie werden bei Genehmigung benachrichtigt.',
      sideHome: 'Startseite', sideAbout: 'Über uns', sideContact: 'Kontakt',
    },
    landing: {
      aiBadge: 'KI-gestützte Immobilien-Berichterstattung',
      watchDemo: 'Demo ansehen',
      statReports: 'Berichte erstellt',
      statConsultants: 'Aktive Berater',
      statOffices: 'Immobilienbüros',
      featuresBadge: 'Funktionen',
      featuresTitle: 'Alles in einer Plattform',
      featuresSubtitle: 'Tools, die Ihre Arbeitsabläufe beschleunigen mit professionellem Aussehen',
      aiTitle: 'Professionelle Analyse',
      aiTitleGrad: 'in Sekunden',
      aiTitleEnd: 'mit KI',
      aiSubtitle: 'Überlassen Sie der KI stundenlange Marktrecherchen und Berichterstellung. Konzentrieren Sie sich nur auf Ihren Kunden.',
      aiGeminiBadge: 'Google Gemini AI Technologie',
      aiStep: 'SCHRITT',
      aiStep1Title: 'Dateneingabe',
      aiStep1Desc: 'Geben Sie Inserat-Details, Standort und Preisbereich ein',
      aiStep1Items: ['Adresse & Standort', 'Qm & Zimmer', 'Preisbereich'],
      aiStep2Title: 'KI-Analyse',
      aiStep2Desc: 'Gemini AI analysiert tausende vergleichbare Inserate und bewertet den Markt',
      aiStep2Items: ['Vergleichsanalyse', 'Marktanalyse', 'Preisschätzung'],
      aiStep3Title: 'Professioneller Bericht',
      aiStep3Desc: 'Ein gebrandeter, PDF-fähiger, teilbarer Bericht wird erstellt',
      aiStep3Items: ['PDF herunterladen', 'Per Link teilen', 'Markenidentität'],
      aiFeatures: [
        { title: 'Automatische Marktanalyse', desc: 'Verkaufstrends, Preisbewegungen und Marktdynamik werden automatisch analysiert.' },
        { title: 'Vergleichsinserat-Vergleich', desc: 'Ähnliche Inserate werden gefunden und eine detaillierte Vergleichstabelle erstellt.' },
        { title: 'Intelligente Preisschätzung', desc: 'Realistischer Preisbereich basierend auf Standort, Fläche und Merkmalen berechnet.' },
        { title: 'Automatische Berichterstellung', desc: 'Alle Analysen werden professionell berichtet, kein manuelles Schreiben nötig.' },
        { title: 'In Sekunden fertig', desc: 'Stundenlange Analysen werden dank KI in Minuten abgeschlossen.' },
        { title: 'Sicher & Privat', desc: 'Alle Ihre Daten werden verschlüsselt gespeichert, Kundendatenschutz vollständig gewährleistet.' },
      ],
      howBadge: 'So funktioniert es', howTitle: 'In 3 Schritten loslegen',
      howSubtitle: 'Kein Setup erforderlich, in Minuten bereit',
      pricingBadge: 'Preise', pricingTitle: 'Einfach & Transparent',
      pricingSubtitle: 'Keine Überraschungen, keine versteckten Gebühren',
      pricingMonthly: '/Monat', pricingNoCard: 'Keine Kreditkarte erforderlich',
      pricingFreeAfter: 'Nach Genehmigung vollständig kostenlos',
      pricingIndividual: 'Einzelberater',
      pricingOffice: 'Immobilienbüro',
      pricingIndividualFeatures: [
        'Unbegrenzte Berichterstellung', 'Hochwertiger PDF-Download', 'Sicheres Link-Sharing',
        'KI-Vergleichsanalyse', 'Gebrandete Berichte', 'Mobilfreundliches Panel', 'Technischer Support',
      ],
      pricingOfficeFeatures: [
        'Alle Einzelplan-Funktionen', 'Büro-Admin-Panel', 'Unbegrenzte Beraterkonten',
        'Berater-Performance-Tracking', 'Zugang zu allen Büroberichten', 'Bürogebrandete Berichte',
        'Benutzerdefiniertes Logo & Farben', 'Priorisierter technischer Support',
      ],
      pricingStartFree: 'Jetzt starten — Kostenlos',
      pricingApplyOffice: 'Büro-Bewerbung',
      testimonialsBadge: 'Nutzerbewertungen',
      testimonialsTitle: 'Was Berater sagen',
      testimonialsSubtitle: 'Von Tausenden Profis vertraut',
      faqBadge: 'FAQ', faqTitle: 'Häufig gestellte\nFragen',
      faqSubtitle: 'Antworten auf alles, was Sie über unsere Plattform wissen möchten.',
      faqNotFound: 'Keine Antwort gefunden?', faqSupport: 'Unser Support-Team ist 24/7 verfügbar.',
      faqContactUs: 'Kontaktieren Sie uns', faqResponseTime: 'Durchschnittliche Antwortzeit: 2 Stunden',
      ctaTitle: 'Bereit loszulegen?',
      ctaSubtitle: 'Erstellen Sie Ihr kostenloses Konto und bereiten Sie Ihren ersten Bericht in Minuten vor.',
      ctaBtn: 'Kostenlos starten',
      footerQuickAccess: 'Schnelllinks', footerContact: 'Kontakt',
      footerLinks: [['Startseite', '/'], ['Über uns', '/hakkimizda'], ['Kontakt', '/iletisim'], ['Anmelden', '/login']],
    },
    dashboard: {
      dashboard: 'Dashboard', reports: 'Berichte', myReports: 'Meine Berichte',
      listings: 'Inserate', myListings: 'Meine Inserate', newReport: 'Neuer Bericht',
      users: 'Benutzer', stores: 'Shops', apiKeys: 'API-Schlüssel',
      stats: 'Statistiken', siteContent: 'Website-Inhalt', siteSettings: 'Website-Einstellungen',
      packages: 'Pakete', contactMessages: 'Kontaktnachrichten',
      support: 'Support', supportTickets: 'Support-Tickets',
      consultants: 'Berater', myApiKey: 'Mein API-Schlüssel', myStats: 'Meine Statistiken',
      notifications: 'Benachrichtigungen', profile: 'Profil', settings: 'Einstellungen', logout: 'Abmelden',
    },
    common: {
      save: 'Speichern', cancel: 'Abbrechen', delete: 'Löschen', edit: 'Bearbeiten', add: 'Hinzufügen',
      search: 'Suchen', loading: 'Wird geladen...', saving: 'Wird gespeichert...', confirm: 'Bestätigen',
      close: 'Schließen', yes: 'Ja', no: 'Nein', actions: 'Aktionen', status: 'Status',
      date: 'Datum', name: 'Name', email: 'E-Mail', phone: 'Telefon', back: 'Zurück',
      next: 'Weiter', submit: 'Absenden', upload: 'Hochladen', download: 'Herunterladen', print: 'Drucken',
      preview: 'Vorschau', share: 'Teilen', copy: 'Kopieren', reset: 'Zurücksetzen', refresh: 'Aktualisieren',
      total: 'Gesamt', active: 'Aktiv', passive: 'Inaktiv', approved: 'Genehmigt',
      pending: 'Ausstehend', rejected: 'Abgelehnt',
    },
    siteSettings: {
      languageTitle: 'Spracheinstellungen',
      languageDesc: 'Wählen Sie die Standardsprache. Besucher können die Sprache jederzeit ändern.',
      defaultLanguage: 'Standard-Website-Sprache',
    },
    reports: {
      title: 'Berichte', subtitle: 'Alle Berichte anzeigen und verwalten',
      newReport: 'Neuer Bericht', createNew: 'Neuen Bericht erstellen',
      searchPlaceholder: 'Nach Bericht, Berater, Kunde suchen...',
      selectMode: 'Auswählen', deselectAll: 'Auswahl aufheben', selectAll: 'Alle auswählen',
      untitled: 'Unbenannter Bericht', archivedBadge: 'Archiviert',
      preparing: 'In Vorbereitung', pendingApproval: 'Ausstehend',
      readyForPresentation: 'Präsentationsbereit', completed: 'Abgeschlossen',
      consultant: 'Berater', customer: 'Kunde',
      restore: 'Wiederherstellen', archiveTab: 'Archiv',
      noReports: 'Noch keine Berichte', noArchived: 'Keine archivierten Berichte',
      archivedDesc: 'Archivierte Berichte erscheinen hier.', noResults: 'Keine Ergebnisse',
      loadError: 'Berichte konnten nicht geladen werden', deleted: 'Bericht gelöscht', deleteError: 'Löschen fehlgeschlagen',
      archived: 'Bericht archiviert', archiveError: 'Archivierung fehlgeschlagen',
      restored: 'Bericht wiederhergestellt', restoreError: 'Wiederherstellung fehlgeschlagen',
      pdfError: 'PDF konnte nicht erstellt werden', linkCopied: 'Link kopiert!',
      linkError: 'Link konnte nicht erstellt werden', statusUpdated: 'Status aktualisiert',
      statusError: 'Status konnte nicht aktualisiert werden', bulkDeleted: 'Berichte gelöscht',
      bulkDeleteError: 'Einige Berichte konnten nicht gelöscht werden',
      deleteConfirmTitle: 'Diesen Bericht wirklich löschen?',
      deleteConfirmDesc: 'Diese Aktion kann nicht rückgängig gemacht werden.',
      bulkDeleteConfirmDesc: 'Diese Aktion kann nicht rückgängig gemacht werden. Ausgewählte Berichte werden gelöscht.',
    },
    listings: {
      title: 'Inserate', subtitle: 'Inserate für monatliche Berichte verwalten',
      newListing: 'Neues Inserat', searchPlaceholder: 'Inserate suchen...',
      activeListings: 'Aktive Inserate', archive: 'Archiv',
      noListings: 'Noch keine Inserate', noSearchResults: 'Keine Inserate gefunden.',
      noArchived: 'Keine archivierten Inserate', archivedListingsDesc: 'Gelöschte Inserate erscheinen hier.',
      addFirstListing: 'Klicken Sie auf "Neues Inserat" zum Hinzufügen.',
      noAssigned: 'Keine zugewiesenen Inserate.',
      editListing: 'Inserat bearbeiten', addListing: 'Inserat hinzufügen',
      titleLabel: 'Inserattitel', priceLabel: 'Preis', currencyLabel: 'Währung',
      platforms: 'Plattform-Inseratnummern', addPlatform: '+ Plattform hinzufügen',
      platformName: 'Plattformname', listingNo: 'Inseratnr.',
      assignConsultant: 'Berater zuweisen', unassigned: 'Nicht zugewiesen',
      noConsultants: 'Keine Berater im System',
      customerInfo: 'Kundendaten (optional)',
      customerName: 'Kundenname', customerPhone: 'Telefon', customerEmail: 'Email',
      reportDate: 'Berichtsdatum', reportDateNote: 'Erinnerung 7 Tage vorher.',
      notes: 'Notizen', notesPlaceholder: 'Zusätzliche Notizen...',
      dialogDesc: 'Insertdaten eingeben.',
      archivedBadge: 'Archiviert', archiveDate: 'Archiviert am',
      notDetermined: 'Nicht festgelegt', lastReport: 'Letzter Bericht',
      daysLeft: 'Tage übrig', overdue: 'Überfällig', passive: 'Inaktiv',
      totalListings: 'Inserate gesamt', activeCount: 'Aktiv',
      upcomingReports: 'Berichte in 7 Tagen', delayedReports: 'Überfällig',
      markedReported: 'Als berichtet markieren', restore: 'Wiederherstellen', permanentDelete: 'Endgültig löschen',
      sessionExpired: 'Sitzung abgelaufen. Bitte erneut anmelden.',
      loadError: 'Inserate konnten nicht geladen werden.', titlePriceRequired: 'Titel und Preis erforderlich',
      updated: 'Inserat aktualisiert', created: 'Inserat erstellt', saveError: 'Speichern fehlgeschlagen',
      archived: 'Inserat archiviert', archiveError: 'Archivierung fehlgeschlagen',
      restored: 'Inserat wiederhergestellt', restoreError: 'Wiederherstellung fehlgeschlagen',
      permanentlyDeleted: 'Inserat dauerhaft gelöscht', deleteError: 'Löschen fehlgeschlagen',
      markedReportedToast: 'Als berichtet markiert. Nächstes: +30 Tage',
      undoReportedToast: 'Berichtstatus rückgängig gemacht',
      noConsultantAssigned: 'Kein Berater zugewiesen',
      notifyError: 'Benachrichtigung fehlgeschlagen', operationFailed: 'Vorgang fehlgeschlagen',
      archiveConfirmTitle: 'Inserat archivieren',
      archiveConfirmDesc: 'Inserat archivieren? Es kann später wiederhergestellt werden.',
      permanentDeleteConfirmTitle: 'Endgültig löschen',
      permanentDeleteConfirmDesc: 'Endgültig löschen? Dies kann nicht rückgängig gemacht werden.',
      noResults: 'Keine Ergebnisse', consultantsLoading: 'Wird geladen...',
    },
    users: {
      title: 'Benutzerverwaltung', searchPlaceholder: 'Nach Name oder E-Mail suchen...',
      total: 'Gesamt', addedByAdmin: 'Vom Admin hinzugefügt',
      newUser: 'Neuer Benutzer', fullName: 'Vollständiger Name', emailLabel: 'E-Mail',
      passwordLabel: 'Passwort', roleLabel: 'Rolle',
      usersTitle: 'Benutzer',
      colUser: 'Benutzer', colRole: 'Rolle', colStatus: 'Status', colDuration: 'Laufzeit', colActions: 'Aktionen',
      roleAll: 'Alle', roleSuperAdmin: 'Super-Admin', roleStoreAdmin: 'Shop-Admin',
      roleConsultant: 'Berater', roleIndividual: 'Einzelbenutzer',
      roleSuperAdminLabel: 'Super-Admin', roleStoreManagerLabel: 'Shop-Manager',
      roleConsultantLabel: 'Berater', roleIndividualLabel: 'Einzeln',
      storeUser: 'Shop-Benutzer', individualUser: 'Einzelbenutzer',
      editTitle: 'Benutzer bearbeiten',
      newPassword: 'Neues Passwort (leer lassen zum Behalten)',
      newPasswordPlaceholder: 'Neues Passwort eingeben...',
      roleChangeNote: 'Rollenänderung wird bei nächster Anmeldung aktiv.',
      addDuration: 'Laufzeit hinzufügen', durationTitle: 'Laufzeit hinzufügen',
      durationSelect: 'Laufzeit wählen', currentExpiry: 'Aktuelles Ablaufdatum',
      durationNote: '* Zur aktuellen Laufzeit addiert. Falls abgelaufen, ab heute.',
      manualDays: 'Manuelle Tage', manualDaysPlaceholder: 'z.B. 45',
      durationBtn: 'Laufzeit hinzufügen',
      active: 'Aktiv', suspended: 'Gesperrt',
      deactivateTitle: 'Sperren', activateTitle: 'Aktivieren',
      expired: 'Abgelaufen', daysLeft: 'T. übrig',
      loadError: 'Liste konnte nicht geladen werden', added: 'Benutzer hinzugefügt', error: 'Ein Fehler ist aufgetreten',
      deactivated: 'Konto gesperrt', activated: 'Konto aktiviert',
      operationFailed: 'Vorgang fehlgeschlagen', deleted: 'Benutzer gelöscht', deleteError: 'Löschen fehlgeschlagen',
      updated: 'Benutzer aktualisiert', updateFailed: 'Aktualisierung fehlgeschlagen',
      invalidDuration: 'Gültige Laufzeit eingeben', durationError: 'Laufzeit konnte nicht hinzugefügt werden',
      durationAdded: 'Tage hinzugefügt. Ablauf',
      deleteConfirm: 'Diesen Benutzer wirklich löschen?',
      googleRegistered: 'Mit Google registriert', adminAdded: 'Vom Admin hinzugefügt', emailRegistered: 'E-Mail-Registrierung',
    },
    support: {
      title: 'Support-Center', subtitle: 'Melden Sie Probleme — wir helfen Ihnen',
      newRequest: 'Neue Anfrage', newTicketTitle: 'Neue Support-Anfrage',
      subjectLabel: 'Betreff', categoryLabel: 'Kategorie', descriptionLabel: 'Beschreibung', priorityLabel: 'Priorität',
      subjectPlaceholder: 'Problem kurz beschreiben', descriptionPlaceholder: 'Problem detailliert beschreiben...',
      categoryTechnical: 'Technisches Problem', categoryAccount: 'Konto', categoryReport: 'Bericht', categoryOther: 'Sonstiges',
      priorityLow: 'Niedrig', priorityNormal: 'Normal', priorityHigh: 'Hoch',
      statusAll: 'Alle', statusOpen: 'Offen', statusInProgress: 'In Bearbeitung', statusResolved: 'Gelöst', statusClosed: 'Geschlossen',
      noTickets: 'Noch keine Support-Anfragen', createFirst: 'Erste Anfrage erstellen',
      submitBtn: 'Anfrage erstellen', submitting: 'Wird erstellt...',
      replyPlaceholder: 'Antwort schreiben...', sendReply: 'Senden', images: 'Bild(er)',
      deleteTicketConfirm: 'Diese Anfrage wirklich löschen?',
      loadError: 'Anfragen konnten nicht geladen werden', created: 'Support-Anfrage erstellt', createError: 'Anfrage konnte nicht erstellt werden',
      subjectDescRequired: 'Betreff und Beschreibung erforderlich', deleted: 'Anfrage gelöscht', deleteError: 'Löschen fehlgeschlagen',
      msgLoadError: 'Nachrichten konnten nicht geladen werden', msgSendError: 'Nachricht konnte nicht gesendet werden',
      imageUploadError: 'Bild konnte nicht hochgeladen werden', deleteTitle: 'Anfrage löschen',
      adminTitle: 'Support-Tickets', allPriorities: 'Alle Prioritäten',
      replyToUser: 'Antwort an Benutzer schreiben...', urgent: 'Dringend',
    },
  },

  // ══════════════════════════════════════════════════════
  // FARSÇA
  // ══════════════════════════════════════════════════════
  fa: {
    nav: {
      home: 'صفحه اصلی', whatWeDo: 'خدمات ما', about: 'درباره ما',
      blog: 'وبلاگ', contact: 'تماس با ما', login: 'ورود',
      register: 'ثبت‌نام رایگان', registerShort: 'ثبت‌نام',
    },
    auth: {
      tabLogin: 'ورود', tabRegister: 'ثبت‌نام فردی', tabStore: 'درخواست فروشگاه',
      email: 'ایمیل', password: 'رمز عبور', fullName: 'نام کامل', phone: 'تلفن',
      phoneOptional: 'تلفن (اختیاری)', passwordConfirm: 'تأیید رمز عبور',
      forgotPassword: 'رمز عبور را فراموش کردم', forgotPasswordTitle: 'فراموشی رمز عبور',
      forgotPasswordDesc: 'آدرس ایمیل ثبت‌شده خود را وارد کنید. لینک بازنشانی رمز عبور ارسال می‌کنیم.',
      emailAddress: 'آدرس ایمیل', sendResetLink: 'ارسال لینک بازنشانی',
      sending: 'در حال ارسال...', emailSent: 'ایمیل ارسال شد!',
      emailSentDesc: 'در صورت ثبت، لینک بازنشانی ارسال شد. پوشه هرزنامه را هم بررسی کنید.',
      backToLogin: '← بازگشت به ورود',
      loginBtn: 'ورود', loggingIn: 'در حال ورود...',
      registerBtn: 'ثبت‌نام', registering: 'در حال ثبت‌نام...',
      storeApply: 'ارسال درخواست', storeApplying: 'در حال ارسال...',
      googleLogin: 'ادامه با Google', googleRegister: 'ثبت‌نام با Google',
      orWith: 'یا', orWithEmail: 'یا با ایمیل',
      storeName: 'نام فروشگاه', contactPerson: 'شخص تماس', address: 'آدرس',
      termsConsent: 'شرایط استفاده را خواندم و می‌پذیرم',
      kvkkConsent: 'سیاست حریم خصوصی را خواندم و می‌پذیرم',
      storeNote: 'درخواست شما توسط مدیر بررسی می‌شود و پس از تأیید اطلاع‌رسانی خواهید شد.',
      sideHome: 'صفحه اصلی', sideAbout: 'درباره ما', sideContact: 'تماس با ما',
    },
    landing: {
      aiBadge: 'گزارش‌دهی املاک با هوش مصنوعی',
      watchDemo: 'نمایش دمو',
      statReports: 'گزارش ایجاد شده',
      statConsultants: 'مشاور فعال',
      statOffices: 'دفتر املاک',
      featuresBadge: 'ویژگی‌ها',
      featuresTitle: 'همه چیز در یک پلتفرم',
      featuresSubtitle: 'ابزارهایی که گردش کار شما را با ظاهری حرفه‌ای سرعت می‌بخشند',
      aiTitle: 'تحلیل حرفه‌ای',
      aiTitleGrad: 'در ثانیه‌ها',
      aiTitleEnd: 'با هوش مصنوعی',
      aiSubtitle: 'ساعت‌ها تحقیق در بازار و نوشتن گزارش را به هوش مصنوعی بسپارید. فقط روی مشتری خود تمرکز کنید.',
      aiGeminiBadge: 'فناوری Google Gemini AI',
      aiStep: 'مرحله',
      aiStep1Title: 'ورود داده',
      aiStep1Desc: 'جزئیات آگهی، مکان و محدوده قیمت را وارد کنید',
      aiStep1Items: ['آدرس و مکان', 'متراژ و اتاق', 'محدوده قیمت'],
      aiStep2Title: 'تحلیل AI',
      aiStep2Desc: 'Gemini AI هزاران آگهی مشابه را تحلیل می‌کند و بازار را ارزیابی می‌کند',
      aiStep2Items: ['مقایسه نمونه‌ها', 'تحلیل بازار', 'تخمین قیمت'],
      aiStep3Title: 'گزارش حرفه‌ای',
      aiStep3Desc: 'گزارشی با نشان تجاری، آماده PDF و اشتراک‌گذاری ایجاد می‌شود',
      aiStep3Items: ['دانلود PDF', 'اشتراک‌گذاری با لینک', 'هویت برند'],
      aiFeatures: [
        { title: 'تحلیل خودکار بازار', desc: 'روند فروش، تغییرات قیمت و پویایی بازار در منطقه به طور خودکار تحلیل می‌شود.' },
        { title: 'مقایسه آگهی‌های مشابه', desc: 'آگهی‌های مشابه پیدا شده و جدول مقایسه دقیق ایجاد می‌شود.' },
        { title: 'تخمین هوشمند قیمت', desc: 'محدوده قیمت واقعی بر اساس مکان، متراژ و ویژگی‌ها محاسبه می‌شود.' },
        { title: 'نوشتن خودکار گزارش', desc: 'تمام تحلیل‌ها به زبان حرفه‌ای گزارش می‌شوند، نیازی به نوشتن دستی نیست.' },
        { title: 'آماده در ثانیه‌ها', desc: 'تحلیل‌هایی که ساعت‌ها طول می‌کشند با هوش مصنوعی در دقیقه‌ها کامل می‌شوند.' },
        { title: 'امن و محرمانه', desc: 'تمام داده‌های شما رمزگذاری شده ذخیره می‌شوند، حریم خصوصی مشتری کاملاً محافظت می‌شود.' },
      ],
      howBadge: 'نحوه کار', howTitle: 'در ۳ مرحله شروع کنید',
      howSubtitle: 'نیازی به تنظیم نیست، در چند دقیقه آماده',
      pricingBadge: 'قیمت‌گذاری', pricingTitle: 'ساده و شفاف',
      pricingSubtitle: 'بدون غافلگیری، بدون هزینه‌های پنهان',
      pricingMonthly: '/ماه', pricingNoCard: 'نیازی به کارت اعتباری نیست',
      pricingFreeAfter: 'کاملاً رایگان پس از تأیید',
      pricingIndividual: 'مشاور فردی',
      pricingOffice: 'دفتر املاک',
      pricingIndividualFeatures: [
        'ایجاد گزارش نامحدود', 'دانلود PDF با کیفیت بالا', 'اشتراک‌گذاری لینک امن',
        'تحلیل AI نمونه‌ها', 'گزارش با برند شما', 'پنل سازگار با موبایل', 'پشتیبانی فنی',
      ],
      pricingOfficeFeatures: [
        'همه ویژگی‌های برنامه فردی', 'پنل مدیر دفتر', 'حساب‌های مشاور نامحدود',
        'ردیابی عملکرد مشاوران', 'دسترسی به همه گزارش‌های دفتر', 'گزارش با برند دفتر',
        'لوگو و رنگ‌های سفارشی', 'پشتیبانی فنی اولویت‌دار',
      ],
      pricingStartFree: 'شروع کنید — رایگان',
      pricingApplyOffice: 'درخواست دفتر',
      testimonialsBadge: 'نظرات کاربران',
      testimonialsTitle: 'مشاوران چه می‌گویند؟',
      testimonialsSubtitle: 'مورد اعتماد هزاران متخصص',
      faqBadge: 'سؤالات متداول', faqTitle: 'سؤالات\nمتداول',
      faqSubtitle: 'پاسخ به هر چیزی که درباره پلتفرم ما کنجکاو هستید.',
      faqNotFound: 'پاسخ پیدا نکردید؟', faqSupport: 'تیم پشتیبانی ما ۲۴/۷ در دسترس است.',
      faqContactUs: 'تماس با ما', faqResponseTime: 'میانگین زمان پاسخ: ۲ ساعت',
      ctaTitle: 'آماده شروع هستید؟',
      ctaSubtitle: 'حساب رایگان خود را ایجاد کنید و اولین گزارش را در چند دقیقه آماده کنید.',
      ctaBtn: 'شروع رایگان',
      footerQuickAccess: 'لینک‌های سریع', footerContact: 'تماس با ما',
      footerLinks: [['صفحه اصلی', '/'], ['درباره ما', '/hakkimizda'], ['تماس با ما', '/iletisim'], ['ورود', '/login']],
    },
    dashboard: {
      dashboard: 'داشبورد', reports: 'گزارش‌ها', myReports: 'گزارش‌های من',
      listings: 'آگهی‌ها', myListings: 'آگهی‌های من', newReport: 'گزارش جدید',
      users: 'کاربران', stores: 'فروشگاه‌ها', apiKeys: 'کلیدهای API',
      stats: 'آمار', siteContent: 'محتوای سایت', siteSettings: 'تنظیمات سایت',
      packages: 'بسته‌ها', contactMessages: 'پیام‌های تماس',
      support: 'پشتیبانی', supportTickets: 'تیکت‌های پشتیبانی',
      consultants: 'مشاوران', myApiKey: 'کلید API من', myStats: 'آمار من',
      notifications: 'اعلان‌ها', profile: 'پروفایل', settings: 'تنظیمات', logout: 'خروج',
    },
    common: {
      save: 'ذخیره', cancel: 'لغو', delete: 'حذف', edit: 'ویرایش', add: 'افزودن',
      search: 'جستجو', loading: 'در حال بارگذاری...', saving: 'در حال ذخیره...', confirm: 'تأیید',
      close: 'بستن', yes: 'بله', no: 'خیر', actions: 'اقدامات', status: 'وضعیت',
      date: 'تاریخ', name: 'نام', email: 'ایمیل', phone: 'تلفن', back: 'برگشت',
      next: 'بعدی', submit: 'ارسال', upload: 'آپلود', download: 'دانلود', print: 'چاپ',
      preview: 'پیش‌نمایش', share: 'اشتراک‌گذاری', copy: 'کپی', reset: 'بازنشانی', refresh: 'بازنشانی',
      total: 'مجموع', active: 'فعال', passive: 'غیرفعال', approved: 'تأیید شده',
      pending: 'در انتظار', rejected: 'رد شده',
    },
    siteSettings: {
      languageTitle: 'تنظیمات زبان',
      languageDesc: 'زبان پیش‌فرض سایت را انتخاب کنید. بازدیدکنندگان می‌توانند زبان را تغییر دهند.',
      defaultLanguage: 'زبان پیش‌فرض سایت',
    },
    reports: {
      title: 'گزارش‌ها', subtitle: 'همه گزارش‌های خود را مشاهده و مدیریت کنید',
      newReport: 'گزارش جدید', createNew: 'ایجاد گزارش جدید',
      searchPlaceholder: 'جستجو بر اساس گزارش، مشاور، مشتری...',
      selectMode: 'انتخاب', deselectAll: 'لغو انتخاب', selectAll: 'انتخاب همه',
      untitled: 'گزارش بدون عنوان', archivedBadge: 'بایگانی شده',
      preparing: 'در حال آماده‌سازی', pendingApproval: 'در انتظار تأیید',
      readyForPresentation: 'آماده ارائه', completed: 'تکمیل شده',
      consultant: 'مشاور', customer: 'مشتری',
      restore: 'بازگردانی', archiveTab: 'بایگانی',
      noReports: 'هنوز گزارشی نیست', noArchived: 'گزارش بایگانی‌شده‌ای نیست',
      archivedDesc: 'گزارش‌های بایگانی‌شده اینجا نمایش داده می‌شوند.', noResults: 'نتیجه‌ای یافت نشد',
      loadError: 'بارگذاری گزارش‌ها ناموفق بود', deleted: 'گزارش حذف شد', deleteError: 'حذف ناموفق بود',
      archived: 'گزارش بایگانی شد', archiveError: 'بایگانی ناموفق بود',
      restored: 'گزارش بازگردانی شد', restoreError: 'بازگردانی ناموفق بود',
      pdfError: 'ایجاد PDF ناموفق بود', linkCopied: 'لینک اشتراک‌گذاری کپی شد!',
      linkError: 'ایجاد لینک ناموفق بود', statusUpdated: 'وضعیت به‌روز شد',
      statusError: 'به‌روزرسانی وضعیت ناموفق بود', bulkDeleted: 'گزارش حذف شد',
      bulkDeleteError: 'برخی گزارش‌ها حذف نشدند',
      deleteConfirmTitle: 'آیا از حذف این گزارش اطمینان دارید؟',
      deleteConfirmDesc: 'این عملیات قابل برگشت نیست. گزارش به طور دائم حذف می‌شود.',
      bulkDeleteConfirmDesc: 'این عملیات قابل برگشت نیست. گزارش‌های انتخاب‌شده به طور دائم حذف می‌شوند.',
    },
    listings: {
      title: 'آگهی‌ها', subtitle: 'آگهی‌ها را برای گزارش‌های ماهانه مدیریت کنید',
      newListing: 'آگهی جدید', searchPlaceholder: 'جستجوی آگهی...',
      activeListings: 'آگهی‌های فعال', archive: 'بایگانی',
      noListings: 'هنوز آگهی‌ای اضافه نشده', noSearchResults: 'آگهی‌ای با معیار جستجو یافت نشد.',
      noArchived: 'آگهی بایگانی‌شده‌ای نیست', archivedListingsDesc: 'آگهی‌های حذف‌شده اینجا نمایش داده می‌شوند.',
      addFirstListing: 'برای افزودن اولین آگهی روی "آگهی جدید" کلیک کنید.',
      noAssigned: 'آگهی تخصیص‌یافته‌ای ندارید.',
      editListing: 'ویرایش آگهی', addListing: 'افزودن آگهی جدید',
      titleLabel: 'عنوان آگهی', priceLabel: 'قیمت', currencyLabel: 'واحد پول',
      platforms: 'شماره آگهی در پلتفرم‌ها', addPlatform: '+ افزودن پلتفرم',
      platformName: 'نام پلتفرم', listingNo: 'شماره آگهی',
      assignConsultant: 'تخصیص مشاور', unassigned: 'تخصیص‌نیافته',
      noConsultants: 'مشاوری در سیستم ثبت نشده',
      customerInfo: 'اطلاعات مشتری (اختیاری)',
      customerName: 'نام مشتری', customerPhone: 'تلفن', customerEmail: 'ایمیل',
      reportDate: 'تاریخ گزارش', reportDateNote: 'یادآوری ۷ روز قبل برای مشاور ارسال می‌شود.',
      notes: 'یادداشت‌ها', notesPlaceholder: 'یادداشت‌های اضافی...',
      dialogDesc: 'اطلاعات آگهی را وارد کنید.',
      archivedBadge: 'بایگانی شده', archiveDate: 'تاریخ بایگانی',
      notDetermined: 'تعیین نشده', lastReport: 'آخرین گزارش',
      daysLeft: 'روز مانده', overdue: 'تأخیر', passive: 'غیرفعال',
      totalListings: 'کل آگهی‌ها', activeCount: 'فعال',
      upcomingReports: 'گزارش‌های ۷ روز آینده', delayedReports: 'تأخیر',
      markedReported: 'گزارش داده شد', restore: 'بازگردانی', permanentDelete: 'حذف دائم',
      sessionExpired: 'جلسه منقضی شد. لطفاً دوباره وارد شوید.',
      loadError: 'بارگذاری آگهی‌ها ناموفق بود.', titlePriceRequired: 'عنوان و قیمت الزامی است',
      updated: 'آگهی به‌روز شد', created: 'آگهی ایجاد شد', saveError: 'ذخیره آگهی ناموفق بود',
      archived: 'آگهی بایگانی شد', archiveError: 'بایگانی ناموفق بود',
      restored: 'آگهی بازگردانی شد', restoreError: 'بازگردانی ناموفق بود',
      permanentlyDeleted: 'آگهی به طور دائم حذف شد', deleteError: 'حذف ناموفق بود',
      markedReportedToast: 'به عنوان گزارش‌شده علامت‌گذاری شد. بعدی: +۳۰ روز',
      undoReportedToast: 'وضعیت گزارش لغو شد',
      noConsultantAssigned: 'مشاوری به این آگهی تخصیص نیافته',
      notifyError: 'ارسال اعلان ناموفق بود', operationFailed: 'عملیات ناموفق بود',
      archiveConfirmTitle: 'بایگانی آگهی',
      archiveConfirmDesc: 'آیا می‌خواهید این آگهی را بایگانی کنید؟ بعداً می‌توانید بازگردانی کنید.',
      permanentDeleteConfirmTitle: 'حذف دائم',
      permanentDeleteConfirmDesc: 'آیا از حذف دائم اطمینان دارید؟ این عملیات قابل برگشت نیست.',
      noResults: 'نتیجه‌ای یافت نشد', consultantsLoading: 'در حال بارگذاری...',
    },
    users: {
      title: 'مدیریت کاربران', searchPlaceholder: 'جستجو با نام یا ایمیل...',
      total: 'مجموع', addedByAdmin: 'اضافه‌شده توسط مدیر',
      newUser: 'کاربر جدید', fullName: 'نام کامل', emailLabel: 'ایمیل',
      passwordLabel: 'رمز عبور', roleLabel: 'نقش',
      usersTitle: 'کاربران',
      colUser: 'کاربر', colRole: 'نقش', colStatus: 'وضعیت', colDuration: 'مدت', colActions: 'اقدامات',
      roleAll: 'همه', roleSuperAdmin: 'مدیر اصلی', roleStoreAdmin: 'مدیر فروشگاه',
      roleConsultant: 'مشاور', roleIndividual: 'کاربر فردی',
      roleSuperAdminLabel: 'مدیر اصلی', roleStoreManagerLabel: 'مدیر فروشگاه',
      roleConsultantLabel: 'مشاور', roleIndividualLabel: 'فردی',
      storeUser: 'کاربر فروشگاه', individualUser: 'کاربر فردی',
      editTitle: 'ویرایش کاربر',
      newPassword: 'رمز عبور جدید (برای نگه داشتن خالی بگذارید)',
      newPasswordPlaceholder: 'رمز عبور جدید وارد کنید...',
      roleChangeNote: 'تغییر نقش در ورود بعدی اعمال می‌شود.',
      addDuration: 'افزودن مدت', durationTitle: 'افزودن مدت',
      durationSelect: 'مدت را انتخاب کنید', currentExpiry: 'تاریخ انقضای فعلی',
      durationNote: '* به مدت فعلی اضافه می‌شود. اگر منقضی شده، از امروز شروع می‌شود.',
      manualDays: 'روزهای دستی', manualDaysPlaceholder: 'مثال: ۴۵',
      durationBtn: 'افزودن مدت',
      active: 'فعال', suspended: 'معلق',
      deactivateTitle: 'تعلیق', activateTitle: 'فعال‌سازی',
      expired: 'منقضی شده', daysLeft: 'روز مانده',
      loadError: 'بارگذاری لیست ناموفق بود', added: 'کاربر اضافه شد', error: 'خطایی رخ داد',
      deactivated: 'حساب معلق شد', activated: 'حساب فعال شد',
      operationFailed: 'عملیات ناموفق بود', deleted: 'کاربر حذف شد', deleteError: 'حذف ناموفق بود',
      updated: 'کاربر به‌روز شد', updateFailed: 'به‌روزرسانی ناموفق بود',
      invalidDuration: 'مدت معتبری وارد کنید', durationError: 'افزودن مدت ناموفق بود',
      durationAdded: 'روز اضافه شد. انقضا',
      deleteConfirm: 'آیا از حذف این کاربر اطمینان دارید؟',
      googleRegistered: 'ثبت‌نام با Google', adminAdded: 'اضافه‌شده توسط مدیر', emailRegistered: 'ثبت‌نام با ایمیل',
    },
    support: {
      title: 'مرکز پشتیبانی', subtitle: 'مشکلات خود را گزارش دهید، تیم ما کمک می‌کند',
      newRequest: 'درخواست جدید', newTicketTitle: 'درخواست پشتیبانی جدید',
      subjectLabel: 'موضوع', categoryLabel: 'دسته‌بندی', descriptionLabel: 'توضیحات', priorityLabel: 'اولویت',
      subjectPlaceholder: 'مشکل را به اختصار توضیح دهید', descriptionPlaceholder: 'مشکل را به تفصیل توضیح دهید...',
      categoryTechnical: 'مشکل فنی', categoryAccount: 'حساب', categoryReport: 'گزارش', categoryOther: 'سایر',
      priorityLow: 'پایین', priorityNormal: 'معمولی', priorityHigh: 'بالا',
      statusAll: 'همه', statusOpen: 'باز', statusInProgress: 'در حال بررسی', statusResolved: 'حل شده', statusClosed: 'بسته',
      noTickets: 'هنوز درخواست پشتیبانی ندارید', createFirst: 'اولین درخواست را ایجاد کنید',
      submitBtn: 'ایجاد درخواست', submitting: 'در حال ایجاد...',
      replyPlaceholder: 'پاسخ خود را بنویسید...', sendReply: 'ارسال', images: 'تصویر',
      deleteTicketConfirm: 'آیا از حذف این درخواست اطمینان دارید؟',
      loadError: 'بارگذاری درخواست‌ها ناموفق بود', created: 'درخواست پشتیبانی ایجاد شد', createError: 'ایجاد درخواست ناموفق بود',
      subjectDescRequired: 'موضوع و توضیحات الزامی است', deleted: 'درخواست حذف شد', deleteError: 'حذف ناموفق بود',
      msgLoadError: 'بارگذاری پیام‌ها ناموفق بود', msgSendError: 'ارسال پیام ناموفق بود',
      imageUploadError: 'آپلود تصویر ناموفق بود', deleteTitle: 'حذف درخواست',
      adminTitle: 'تیکت‌های پشتیبانی', allPriorities: 'همه اولویت‌ها',
      replyToUser: 'پاسخ به کاربر بنویسید...', urgent: 'فوری',
    },
  },
};

export default t;
